// src/data/cctvData.js
const cctvData = [
 {
        "name": "วงเวียนน้ำพุอุบล หันหน้าไปยังวารินชำราบ",
        "detail": "วงเวียนน้ำพุอุบล หันหน้าไปยังวารินชำราบ",
        "provine": "อุบลราชธานี",
        "gps": "15.224799569423357, 104.85742640727962",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0082&path=playlist.m3u8"
    },
    {
        "name": "หน้าปั้มเซลล์แยกร่มเกล้า / ทุ่งศรีเมือง",
        "detail": "หน้าปั้มเซลล์แยกร่มเกล้า / ทุ่งศรีเมือง",
        "provine": "อุบลราชธานี",
        "gps": "15.227156362676606, 104.85697006360319",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0085&path=playlist.m3u8"
    },
    {
        "name": "แยกสนามบินนานาชาติ - ปตท สนามบิน",
        "detail": "แยกสนามบินนานาชาติ - ปตท สนามบิน",
        "provine": "อุบลราชธานี",
        "gps": "15.239450693036769,104.86421025305886",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0042&path=playlist.m3u8"
    },
    {
        "name": "หน้าโรงเรียนกีฬาจังหวัดอุบล",
        "detail": "หน้าโรงเรียนกีฬาจังหวัดอุบล",
        "provine": "อุบลราชธานี",
        "gps": "15.252818210031892, 104.84875345967798",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0033&path=playlist.m3u8"
    },
    {
        "name": "แยกเนวาด้าอุบล",
        "detail": "แยกเนวาด้าอุบล",
        "provine": "อุบลราชธานี",
        "gps": "15.246133908455239, 104.85100859615683",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0035&path=playlist.m3u8"
    },
    {
        "name": "สามแยกหนองบัว",
        "detail": "สามแยกหนองบัว - แยกเข้าไปวัดหนองบัว",
        "provine": "อุบลราชธานี",
        "gps": "15.262581084638892, 104.84540239434772",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0030&path=playlist.m3u8"
    },
    {
        "name": "สี่แยกโรงเรียนเบ็ญฯ/ประปา ถนนสรรพสิทธิ์ตัดชลบประทานท่าบ่อ (cctvp2c009)",
        "detail": "สี่แยกโรงเรียนเบ็ญฯ/ประปา ถนนสรรพสิทธิ์ตัดชลบประทานท่าบ่อ (cctvp2c009)",
        "provine": "อุบลราชธานี",
        "gps": "15.238143690626258, 104.8362995809796",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0009&path=playlist.m3u8"
    },
    {
        "name": "หน้า กศน. (หอนาฬิกา) (cctvp2c014)",
        "detail": "หน้า กศน. (หอนาฬิกา) (cctvp2c014)",
        "provine": "อุบลราชธานี",
        "gps": "15.244287996471291, 104.84734923740596",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0014&path=playlist.m3u8"
    },
    {
        "name": "หน้า ปตท สะพานใหม่",
        "detail": "หน้า ปตท สะพานใหม่",
        "provine": "อุบลราชธานี",
        "gps": "15.229144378239674, 104.87127474158059",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0054&path=playlist.m3u8"
    },
    {
        "name": "แยกปั้มเอสโซ่กิโลศูนย์อุบล",
        "detail": "แยกปั้มเอสโซ่กิโลศูนย์อุบล",
        "provine": "อุบลราชธานี",
        "gps": "15.237738560765713, 104.8537839911177",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0037&path=playlist.m3u8"
    },
    {
        "name": "สามแยกผัดไทยหน้ากองบิน",
        "detail": "สามแยกผัดไทยหน้ากองบิน",
        "provine": "อุบลราชธานี",
        "gps": "15.239670014134571, 104.85782017330598",
        "type": "เทศบาล",
        "url": "https://book.teekhawat.com/proxy.php?cam=cam0099&path=playlist.m3u8"
    },
  {
    "name": "214 - อ.เมืองกาฬสินธุ์ จ.กาฬสินธุ์",
    "detail": "ทางหลวงแผ่นดินเหมายเลข 214 ระหว่าง กม. 7-8 ต.ห้วยโพธิ์ อ.เมืองกาฬสินธุ์ จ.กาฬสินธุ์",
    "provine": "กาฬสินธุ์",
    "gps": "16.38603,103.56262",
    "type": "ทางหลวง",
    "url": "http://180.180.242.207:1935/Phase10/PER_10_007.stream/playlist.m3u8"
  },
  {
    "name": "212 - อ.เมืองอำนาจเจริญ จ.อำนาจเจริญ",
    "detail": "212 - อ.เมืองอำนาจเจริญ จ.อำนาจเจริญ",
    "provine": "อำนาจเจริญ",
    "gps": "15.93822,104.62795",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.93822,104.62795",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_013.stream/playlist.m3u8"
  },
  {
    "name": "288-ถนนวงแหวนรอบเมืองบุรีรัมย์",
    "detail": "288-ถนนวงแหวนรอบเมืองบุรีรัมย์",
    "provine": "บุรีรัมย์",
    "gps": "15.0243,103.10034",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.0243,103.10034",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_016.stream/playlist.m3u8"
  },
  {
    "name": "348-ปะคำ - นางรอง",
    "detail": "348-ปะคำ - นางรอง",
    "provine": "บุรีรัมย์",
    "gps": "14.6075,102.77367",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.6075,102.77367",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_017.stream/playlist.m3u8"
  },
  {
    "name": "226 - อ.เมืองสุรินทร์ จ.สุรินทร์",
    "detail": "ทางหลวงแผ่นดินหมายเลข 226 ระหว่าง กม.162-163 ต.คอโค อ.เมืองสุรินทร์ จ.สุรินทร์",
    "provine": "สุรินทร์",
    "gps": "14.81272,103.45585",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.81272,103.45585",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_021.stream/playlist.m3u8"
  },
  {
    "name": "232 - ถนนวงแหวนรอบเมืองร้อยเอ็ด",
    "detail": "ทางหลวงแผ่นดินหมายเลข 232 ระหว่าง กม 17 - 18 ",
    "provine": "ร้อยเอ็ด",
    "gps": "16.04845,103.68141",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.04845,103.68141",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD4KM187.stream/playlist.m3u8"
  },
  {
    "name": "ปากซอยมอเตอร์ไบต์หันหน้าไปยังบิ๊กซีอุบล",
    "detail": "ปากซอยมอเตอร์ไบต์หันหน้าไปยังบิ๊กซีอุบล",
    "provine": "อุบลราชธานี",
    "gps": "15.271719848263038, 104.84239989028079",
    "type": "เทศบาล",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.271719848263038,104.84239989028079",
    "url": "http://183.88.214.137:1935/livecctv/cctvp2c028.stream/playlist.m3u8"
  },
  {
    "name": "23 - อ.คำเขื่อนแก้ว จ.ยโสธร",
    "detail": "23 - อ.คำเขื่อนแก้ว จ.ยโสธร",
    "provine": "ยโสธร",
    "gps": "15.71725,104.24678",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_006.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/15.71725,104.24678"
  },
  {
    "name": "08 - อ.แม่สะเรียง จ.แม่ฮ่องสอน",
    "detail": "ทางหลวงแผ่นดินหมายเลข 108 ระหว่าง กม. 197-198 ต.บ้านกาด อ.แม่สะเรียง จ.แม่ฮ่องสอน",
    "provine": "แม่ฮ่องสอน",
    "gps": "18.20457,97.93694",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_019.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/18.20457,97.93694"
  },
  {
    "name": "2 - อ.บ้านแฮด จ.ขอนแก่น",
    "detail": "ทางหลวงแผ่นดินหมายเลข 2 ระหว่าง กม.317-318 ต.โนนสมบูรณ์ อ.บ้านแฮด จ.ขอนแก่น",
    "provine": "ขอนแก่น",
    "gps": "16.2661,102.77946",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.2661,102.77946",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_023.stream/playlist.m3u8"
  },
  {
    "name": "ถนนมิตรภาพ อ.พล จ.ขอนแก่น",
    "detail": "ถนนมิตรภาพ อ.พล จ.ขอนแก่น",
    "provine": "ขอนแก่น",
    "gps": "15.809305728758224, 102.60721235477992",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.809305728758224,102.60721235477992",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD2KM264.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.พระพุทธบาท จ.สระบุรี ทิศทางมุ่งหน้าเข้า จ.สระบุรี",
    "detail": "1 - อ.พระพุทธบาท จ.สระบุรี ทิศทางมุ่งหน้าเข้า จ.สระบุรี",
    "provine": "สระบุรี",
    "gps": "14.751285, 100.743053",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase10/PER_10_011.stream/playlist.m3u8"
  },
  {
    "name": "ถ.วิภาดีรังสิต ดอนเมือง มุ่งหน้ารังสิต",
    "detail": "ถ.วิภาดีรังสิต ดอนเมือง มุ่งหน้ารังสิต",
    "provine": "กรุงเทพ",
    "gps": "13.72233,101.0419",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase3/PER_3_008_OUT.stream/playlist.m3u8"
  },
  {
    "name": "304 - คลองหลวงแพ่ง - ฉะเชิงเทรา ทิศทางมุ่งหน้าเข้า เขตหนองจอก กรุงเทพฯ",
    "detail": "ทางหลวงแผ่นดินหมายเลข 304 ระหว่าง กม 65 - 66 ",
    "provine": "กรุงเทพ",
    "gps": "13.72233,101.0419",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.72233,101.0419",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_002_IN.stream/playlist.m3u8"
  },
  {
    "name": "ทางด่วน แยกทางด่วนพระราม4",
    "detail": "ทางด่วน แยกทางด่วนพระราม4",
    "provine": "กรุงเทพ",
    "gps": "13.722575, 100.553326",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.14_8003.m3u8"
  },
  {
    "name": "ทางด่วน แยกทางด่วนพระราม4 /2",
    "detail": "ทางด่วน แยกทางด่วนพระราม4 /2",
    "provine": "กรุงเทพ",
    "gps": "13.722356, 100.552607",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.14_8554.m3u8"
  },
  {
    "name": "ทางด่วน แยกทางด่วนพระราม4 /3",
    "detail": "ทางด่วน แยกทางด่วนพระราม4 /3",
    "provine": "กรุงเทพ",
    "gps": "13.723151, 100.552158",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.14_8002.m3u8"
  },
  {
    "name": "ถนนสาทรหน้าสถานเอกอัครราชทูตเยอรมนี",
    "detail": "ถนนสาทรหน้าสถานเอกอัครราชทูตเยอรมนี",
    "provine": "กรุงเทพ",
    "gps": "13.725363, 100.542570",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.15_8552.m3u8"
  },
  {
    "name": "ถนนสาทรหน้าสถานเอกอัครราชทูตเยอรมนี",
    "detail": "ถนนสาทรหน้าสถานเอกอัครราชทูตเยอรมนี",
    "provine": "กรุงเทพ",
    "gps": "13.725363, 100.542570",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.15_8552.m3u8"
  },
  {
    "name": "ถนนสาทรหน้าอาคารไทยวาทาวเวอร์",
    "detail": "ถนนสาทรหน้าอาคารไทยวาทาวเวอร์",
    "provine": "กรุงเทพ",
    "gps": "13.724170, 100.538397",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.15_8551.m3u8"
  },
  {
    "name": "เชิงสะพานตากสิน ฝั่งสาทร มุ่งหน้าถนนสาทร",
    "detail": "เชิงสะพานตากสิน ฝั่งสาทร มุ่งหน้าถนนสาทร",
    "provine": "กรุงเทพ",
    "gps": "13.718432, 100.515928",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.18_8001.m3u8"
  },
  {
    "name": "เชิงสะพานตากสิน ฝั่งสาทร บริเวณจุดกลับใต้สะพาน",
    "detail": "เชิงสะพานตากสิน ฝั่งสาทร บริเวณจุดกลับใต้สะพาน",
    "provine": "กรุงเทพ",
    "gps": "13.718599, 100.515155",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.18_8002.m3u8"
  },
  {
    "name": "ทางพิเศษศรีรัชด้านใต้ถนนกำแพงเพชร",
    "detail": "ทางพิเศษศรีรัชด้านใต้ถนนกำแพงเพชร",
    "provine": "กรุงเทพ",
    "gps": "13.794169, 100.538937",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8801.m3u8"
  },
  {
    "name": "ทางพิเศษศรีรัช ด้านเหนือถนนกำแพงเพชร",
    "detail": "ทางพิเศษศรีรัช ด้านเหนือถนนกำแพงเพชร",
    "provine": "กรุงเทพ",
    "gps": "13.796128, 100.539034",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8801.m3u8"
  },
  {
    "name": "ประชานุกูลไปต่างระดับรัชวิภา",
    "detail": "ประชานุกูลไปต่างระดับรัชวิภา",
    "provine": "กรุงเทพ",
    "gps": "13.830436, 100.539109",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8802.m3u8"
  },
  {
    "name": "MRT วงศ์สว่าง",
    "detail": "MRT วงศ์สว่าง",
    "provine": "กรุงเทพ",
    "gps": "13.828623, 100.527924",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8802.m3u8"
  },
  {
    "name": "304 - พนมสารคาม - เขาหินซ้อน",
    "detail": "304 - พนมสารคาม - เขาหินซ้อน",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.74562,101.46868",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.74562,101.46868",
    "url": "https: //streaming2.highwaytraffic.go.th/P16/PER_16_015.stream/playlist.m3u8"
  },
  {
    "name": "ซำขวาง-เขาหินซ้อน (พนมสารคาม)",
    "detail": "ซำขวาง-เขาหินซ้อน (พนมสารคาม)",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.74453,101.48955",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.74453,101.48955",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD304KM122.stream/playlist.m3u8"
  },
  {
    "name": "โครงการก่อสร้างทางหลวงหมายเลข 365 สายทางเลี่ยงเมือง ฉะเชิงเทราด้านเหนือ",
    "detail": "โครงการก่อสร้างทางหลวงหมายเลข 365 สายทางเลี่ยงเมือง ฉะเชิงเทราด้านเหนือ",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.73055,101.03238",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.73055,101.03238",
    "url": "https://streaming2.highwaytraffic.go.th/IWZ-Phase5/IWZ_5_001.stream/playlist.m3u8"
  },
  {
    "name": "32 - อ.เมือง จ.ชัยนาท ทิศทางมุ่งหน้า จ.สิงห์บุรี",
    "detail": "32 - อ.เมือง จ.ชัยนาท ทิศทางมุ่งหน้า จ.สิงห์บุรี",
    "provine": "ชัยนาท",
    "gps": "15.230323, 100.208710",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8802.m3u8"
  },
  {
    "name": "ปากซอยอิศวร (ถนนศรีธรรมโศกราช) ตัวที่ 1",
    "detail": "1186 ถ. ราชดำเนิน ตำบล ในเมือง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.424200575592197, 99.96182828702841",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST03.m3u8"
  },
  {
    "name": "ปากซอยอิศวร (ถนนศรีธรรมโศกราช) ตัวที่ 2",
    "detail": "1186 ถ. ราชดำเนิน ตำบล ในเมือง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.424200575592197, 99.96182828702841",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST04.m3u8"
  },
  {
    "name": "สี่แยกหัวถนน ตัวที่ 1",
    "detail": "ตำบล มะม่วงสองต้น อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.381307745487486, 99.97245933214904",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST05.m3u8"
  },
  {
    "name": "สี่แยกหัวถนน ตัวที่ 1",
    "detail": "ตำบล มะม่วงสองต้น อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.381307745487486, 99.97245933214904",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST05.m3u8"
  },
  {
    "name": "324 - อ.พนมทวน จ.กาญจนบุรี",
    "detail": "324 - อ.พนมทวน จ.กาญจนบุรี",
    "provine": "กาญจนบุรี",
    "gps": "14.119428, 99.682620",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming2.highwaytraffic.go.th/Phase11/PER_11_022.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/14.119428,99.682620"
  },
  {
    "name": "วัดมาบโป่งขาออก พานทอง",
    "detail": "วัดมาบโป่งขาออก พานทอง",
    "provine": "ชลบุรี",
    "gps": "13.427652, 101.118144",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.208:1935/Phase11/PER_11_026_OUT.stream/playlist.m3u8"
  },
  {
    "name": "แยกโรงเรียนบ้านแหลมแท่น 1",
    "detail": "แยกโรงเรียนบ้านแหลมแท่น 1 ซอยบางแสน-อ่างศิลา 3",
    "provine": "ชลบุรี",
    "gps": "13.302453,100.903143",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss01.m3u8"
  },
  {
    "name": "แยกโรงเรียนบ้านแหลมแท่น 2",
    "detail": "แยกโรงเรียนบ้านแหลมแท่น 2 ซอยบางแสน-อ่างศิลา 3",
    "provine": "ชลบุรี",
    "gps": "13.302999, 100.903455",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss02.m3u8"
  },
  {
    "name": "แยกโรงเรียนบ้านแหลมแท่น 3",
    "detail": "แยกโรงเรียนบ้านแหลมแท่น 1 ซอยบางแสน-อ่างศิลา 3",
    "provine": "ชลบุรี",
    "gps": "13.302999, 100.903455",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss03.m3u8"
  },
  {
    "name": "แยกจรินทร์ 3 ถนนลงหาดบางแสน",
    "detail": "แยกจรินทร์ 3 ถนนลงหาดบางแสน",
    "provine": "ชลบุรี",
    "gps": "13.284820, 100.917909",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss21.m3u8"
  },
  {
    "name": "แยกจรินทร์ 1 ถนนลงหาดบางแสน",
    "detail": "แยกจรินทร์ 1 ถนนลงหาดบางแสน",
    "provine": "ชลบุรี",
    "gps": "13.284909, 100.918011",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss19.m3u8"
  },
  {
    "name": "แยกจรินทร์ 2 ถนนลงหาดบางแสน",
    "detail": "ถนนลงหาดบางแสน 1 ต.แสนสุข อ.เมืองชลบุรี จ.ชลบุรี 20130",
    "provine": "ชลบุรี",
    "gps": "13.284856, 100.918141",
    "type": "เทศบาล",
    "url": "https: //camerai1.iticfoundation.org/hls/ss20.m3u8"
  },
  {
    "name": "หน้า-ม.บูรพา 3 ถนนลงหาดบางแสน ",
    "detail": "หน้า-ม.บูรพา 3 ถนนลงหาดบางแสน ",
    "provine": "ชลบุรี",
    "gps": "13.286052, 100.925029",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss18.m3u8"
  },
  {
    "name": "หน้า-ม.บูรพา 2 ถนนลงหาดบางแสน ",
    "detail": "หน้า-ม.บูรพา 2 ถนนลงหาดบางแสน ",
    "provine": "ชลบุรี",
    "gps": "13.286303, 100.925337",
    "type": "เทศบาล",
    "url": "https: //camerai1.iticfoundation.org/hls/ss17.m3u8"
  },
  {
    "name": "หน้า-ม.บูรพา 1 ถนนลงหาดบางแสน ",
    "detail": "หน้า-ม.บูรพา 1 ถนนลงหาดบางแสน ",
    "provine": "ชลบุรี",
    "gps": "13.286041, 100.925459",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss16.m3u8"
  },
  {
    "name": " แยกแกแล็คซี่ 2",
    "detail": " แยกแกแล็คซี่ 2",
    "provine": "ชลบุรี",
    "gps": "13.286357, 100.939127",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss11.m3u8"
  },
  {
    "name": "แยกไทยพิพัฒน์ 2 ทางหลวงแผ่นดินหมายเลข 3144 ต.เหมือง อ.เมืองชลบุรี จ.ชลบุรี 20130",
    "detail": "แยกไทยพิพัฒน์ 2 ทางหลวงแผ่นดินหมายเลข 3144 ต.เหมือง อ.เมืองชลบุรี จ.ชลบุรี 20130",
    "provine": "ชลบุรี",
    "gps": "13.277649, 100.944162",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss19.m3u8"
  },
  {
    "name": "แยกไทยพิพัฒน์ 1 ทางหลวงแผ่นดินหมายเลข 3144 ต.เหมือง อ.เมืองชลบุรี จ.ชลบุรี 20130",
    "detail": "แยกไทยพิพัฒน์ 1 ทางหลวงแผ่นดินหมายเลข 3144 ต.เหมือง อ.เมืองชลบุรี จ.ชลบุรี 20130",
    "provine": "ชลบุรี",
    "gps": "13.277310, 100.944172",
    "type": "เทศบาล",
    "url": "https: //camerai1.iticfoundation.org/hls/ss08.m3u8"
  },
  {
    "name": "แยกจรรยา 1 ถนนสุขุมวิท ต.แสนสุข อ.เมืองชลบุรี จ.ชลบุรี ",
    "detail": "แยกจรรยา 1 ถนนสุขุมวิท ต.แสนสุข อ.เมืองชลบุรี จ.ชลบุรี ",
    "provine": "ชลบุรี",
    "gps": "13.251382, 100.933695",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss04.m3u8"
  },
  {
    "name": "แยกจรรยา 2 ถนนสุขุมวิท ต.แสนสุข อ.เมืองชลบุรี จ.ชลบุรี ",
    "detail": "แยกจรรยา 2 ถนนสุขุมวิท ต.แสนสุข อ.เมืองชลบุรี จ.ชลบุรี ",
    "provine": "ชลบุรี",
    "gps": "13.251117, 100.933869",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss19.m3u8"
  },
  {
    "name": "แยกจรรยา 3 ถนนสุขุมวิท ต.แสนสุข อ.เมืองชลบุรี จ.ชลบุรี",
    "detail": "แยกจรรยา 3 ถนนสุขุมวิท ต.แสนสุข อ.เมืองชลบุรี จ.ชลบุรี ",
    "provine": "ชลบุรี",
    "gps": "13.250925, 100.933635",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss06.m3u8"
  },
  {
    "name": "หน้าธนาคารกสิกรไทย สาขาตลาดนาเกลือ",
    "detail": "หน้าธนาคารกสิกรไทย สาขาตลาดนาเกลือ",
    "provine": "ชลบุรี",
    "gps": "12.971114, 100.903713",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty30.m3u8"
  },
  {
    "name": " ถนนพัทยา-นาเกลือ",
    "detail": " ถนนพัทยา-นาเกลือ",
    "provine": "ชลบุรี",
    "gps": "12.962882, 100.896065",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty32.m3u8"
  },
  {
    "name": "หน้าลุมพินีวิลล์ นาเกลือ-วงศ์อมาตย์",
    "detail": " หน้าลุมพินีวิลล์ นาเกลือ-วงศ์อมาตย์",
    "provine": "ชลบุรี",
    "gps": "12.957780, 100.892235",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/ss08.m3u8"
  },
  {
    "name": "แยกถนนพัทยาเหนือ-ถนนเพ็ชรตระกูล",
    "detail": "แยกถนนพัทยาเหนือ-ถนนเพ็ชรตระกูล",
    "provine": "ชลบุรี",
    "gps": "12.950574, 100.891171",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty21.m3u8"
  },
  {
    "name": "แยกถนนพัทยาเหนือ-ถนนเพ็ชรตระกูล 2",
    "detail": "แยกถนนพัทยาเหนือ-ถนนเพ็ชรตระกูล",
    "provine": "ชลบุรี",
    "gps": "12.950523, 100.891267",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty17.m3u8"
  },
  {
    "name": " ทางแยกปริญญา",
    "detail": " ทางแยกปริญญา",
    "provine": "ชลบุรี",
    "gps": "12.949916, 100.897349",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty22.m3u8"
  },
  {
    "name": "จุดกลับรถหน้าเทคนิคออโต้แอร์ ซอยสุขุมวิทพัทยา 22",
    "detail": "จุดกลับรถหน้าเทคนิคออโต้แอร์ ซอยสุขุมวิทพัทยา 22",
    "provine": "ชลบุรี",
    "gps": "12.962503, 100.909239",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty26.m3u8"
  },
  {
    "name": "จุดกลับรถเมืองจำลอง",
    "detail": "จุดกลับรถเมืองจำลอง",
    "provine": "ชลบุรี",
    "gps": "12.956899, 100.907651",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty27.m3u8"
  },
  {
    "name": "ซอยพรประภานิมิต",
    "detail": "ซอยพรประภานิมิต",
    "provine": "ชลบุรี",
    "gps": "12.934857, 100.901407",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty15.m3u8"
  },
  {
    "name": "พัทยากลางสาย 2 บริเวณศูนย์การค้าบิ๊กซี",
    "detail": "พัทยากลางสาย 2 บริเวณศูนย์การค้าบิ๊กซี",
    "provine": "ชลบุรี",
    "gps": "12.945491, 100.888918",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty22.m3u8"
  },
  {
    "name": "ปากซอย 6 ถนนสายชายหาด",
    "detail": "ปากซอย 6 ถนนสายชายหาด",
    "provine": "ชลบุรี",
    "gps": "12.942564, 100.884627",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty23.m3u8"
  },
  {
    "name": "ถนนพัทยาใต้ ปากซอยพัทยาใต้ 7",
    "detail": "ถนนพัทยาใต้ ปากซอยพัทยาใต้ 7",
    "provine": "ชลบุรี",
    "gps": "12.922351, 100.885067",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty33.m3u8"
  },
  {
    "name": "จุดกลับรถเขาตาโล",
    "detail": "จุดกลับรถเขาตาโล",
    "provine": "ชลบุรี",
    "gps": "12.910022, 100.896150",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty11.m3u8"
  },
  {
    "name": "ปากซอยสุขุมวิทพัทยา 54",
    "detail": " ปากซอยสุขุมวิทพัทยา 54",
    "provine": "ชลบุรี",
    "gps": "12.901250, 100.896549",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty24.m3u8"
  },
  {
    "name": "สามแยกเทพพระยา",
    "detail": "สามแยกเทพพระยา",
    "provine": "ชลบุรี",
    "gps": "12.904531, 100.869279",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty33.m3u8"
  },
  {
    "name": "แยกถนนจอมเทียนสาย 2 ตัดกับถนนขวัญเมือง",
    "detail": "แยกถนนจอมเทียนสาย 2 ตัดกับถนนขวัญเมือง",
    "provine": "ชลบุรี",
    "gps": "12.893133, 100.876701",
    "type": "เทศบาล",
    "url": "https://camerai1.iticfoundation.org/hls/pty10.m3u8"
  },
  {
    "name": "331 - สัตหีบ - เขาบายศรี",
    "detail": "331 - สัตหีบ - เขาบายศรี",
    "provine": "ชลบุรี",
    "gps": "12.70633,100.97294",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.70633,100.97294",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_013.stream/playlist.m3u8"
  },
  {
    "name": "331 - เขาบายศรี - พันเสด็จนอก",
    "detail": "331 - เขาบายศรี - พันเสด็จนอก",
    "provine": "ชลบุรี",
    "gps": "12.74149,100.99058",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.74149,100.99058",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_014.stream/playlist.m3u8"
  },
  {
    "name": "สี่แยกหัวถนน ตัวที่ 2",
    "detail": "ตำบล มะม่วงสองต้น อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.381307745487486, 99.97245933214904",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST06.m3u8"
  },
  {
    "name": "หน้าโรงพยาบาลมหาราช ตัวที่ 1",
    "detail": "198 ถ. ราชดำเนิน ตําบล ในเมือง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.389834062753359, 99.97095925705052",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST07.m3u8"
  },
  {
    "name": "หน้าโรงพยาบาลมหาราช ตัวที่ 2",
    "detail": "198 ถ. ราชดำเนิน ตําบล ในเมือง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.389834062753359, 99.97095925705052",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST08.m3u8"
  },
  {
    "name": "ซอยสระเรียง ตัวที่ 1",
    "detail": "109 ถนน ศรีธรรมโศก ตำบล ในเมือง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.413471200669932, 99.96644054263402",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST09.m3u8"
  },
  {
    "name": "ซอยสระเรียง ตัวที่ 2",
    "detail": "109 ถนน ศรีธรรมโศก ตำบล ในเมือง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.413471200669932, 99.96644054263402",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST10.m3u8"
  },
  {
    "name": "แยกศาลากลาง ตัวที่ 1",
    "detail": "22 ซอย อัศวรักษ์ 1 ตำบล ในเมือง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.420415262307387, 99.96454615284642",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST13.m3u8"
  },
  {
    "name": "แยกศาลากลาง ตัวที่ 2",
    "detail": "22 ซอย อัศวรักษ์ 1 ตำบล ในเมือง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.420415262307387, 99.96454615284642",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST14.m3u8"
  },
  {
    "name": "วงเวียนน้ำพุ ตัวที่ 1",
    "detail": "CXJ6+4VW ตำบล คลัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.430443773149873, 99.96304690119831",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST15.m3u8"
  },
  {
    "name": "วงเวียนน้ำพุ ตัวที่ 2",
    "detail": "CXJ6+4VW ตำบล คลัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.430443773149873, 99.96304690119831",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST16.m3u8"
  },
  {
    "name": "หน้าเทศบาล ตัวที่ 1",
    "detail": "1082/1, Ratchadamnoen Road, Tambon Khlang, Amphoe MueangNakhon Si Thammarat, 80000, 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.437058632091759, 99.96236797828341",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST17.m3u8"
  },
  {
    "name": "หน้าเทศบาล ตัวที่ 2",
    "detail": "1082/1, Ratchadamnoen Road, Tambon Khlang, Amphoe MueangNakhon Si Thammarat, 80000, 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.437058632091759, 99.96236797828341",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST17.m3u8"
  },
  {
    "name": "สามแยกเทวราช ตัวที่ 1",
    "detail": "1656 ถ. ราชดำเนิน ตำบล ท่าวัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.443180567666257, 99.96149597025462",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST19.m3u8"
  },
  {
    "name": "สามแยกเทวราช ตัวที่ 2",
    "detail": "1656 ถ. ราชดำเนิน ตำบล ท่าวัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.443180567666257, 99.96149597025462",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST20.m3u8"
  },
  {
    "name": "สะพานราเมศวร์",
    "detail": "CXV6+QFC ตำบล ท่าซัก อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.444475302517919, 99.96110973871501",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST21.m3u8"
  },
  {
    "name": "ทางเข้าออกสมามกีฬา ตัวที่ 1",
    "detail": "103 ซอย 4016 ตำบล ท่าวัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.455343688504808, 99.95949606038344",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NSS02.m3u8"
  },
  {
    "name": "ทางเข้าออกสมามกีฬา ตัวที่ 2",
    "detail": "103 ซอย 4016 ตำบล ท่าวัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.455343688504808, 99.95949606038344",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST22.m3u8"
  },
  {
    "name": "หลังเทศบาล",
    "detail": "1138 ถนน ศรีปราชญ์ ตำบล ท่าวัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.436293899487842, 99.96354697857775",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST24.m3u8"
  },
  {
    "name": "สี่แยกประตูขาว ตัวที่ 1",
    "detail": "ถ. ราชดำเนิน ตำบล คลัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.43061813412146, 99.96447427720662",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST26.m3u8"
  },
  {
    "name": "สี่แยกประตูขาว ตัวที่ 2",
    "detail": "ถ. ราชดำเนิน ตำบล คลัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.43061813412146, 99.96447427720662",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST27.m3u8"
  },
  {
    "name": "แยกมุมป้อม ตัวที่ 1",
    "detail": "658 ถ. ราชดำเนิน ตำบล คลัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.428181471269584, 99.96330320943169",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST58.m3u8"
  },
  {
    "name": "แยกมุมป้อม ตัวที่ 2",
    "detail": "658 ถ. ราชดำเนิน ตำบล คลัง อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.428181471269584, 99.96330320943169",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST35.m3u8"
  },
  {
    "name": "สี่แยกเบญจมฯ ตัวที่ 1",
    "detail": "CWMC+JJ5 ตำบล โพธิ์เสด็จ อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.433927690680008, 99.9219852395081",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST58.m3u8"
  },
  {
    "name": "สี่แยกเบญจมฯ ตัวที่ 2",
    "detail": "CWMC+JJ5 ตำบล โพธิ์เสด็จ อำเภอเมืองนครศรีธรรมราช นครศรีธรรมราช 80000",
    "provine": "นครศรีธรรมราช",
    "gps": "8.433927690680008, 99.9219852395081",
    "type": "ทางหลวง",
    "url": "https://streaming.noc.nakhoncity.org/live/NST59.m3u8"
  },
  {
    "name": "1020 - อ.เมืองเชียงราย จ.เชียงราย",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1 ระหว่าง กม 942 - 943 ",
    "provine": "เชียงราย",
    "gps": "19.85537,99.84538",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/19.85537,99.84538",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_033.stream/playlist.m3u8"
  },
  {
    "name": "1016 - แม่จัน - กิ่วพร้าว ทิศทางมุ่งหน้าเข้า อ.แม่จัน จ.เชียงราย",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1016 ระหว่าง กม 9 - 10 ",
    "provine": "เชียงราย",
    "gps": "20.20478,99.92572",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/20.20478,99.92572",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_004.stream/playlist.m3u8"
  },
  {
    "name": "418-ยุโป - ท่าสาป",
    "detail": "418-ยุโป - ท่าสาป",
    "provine": "ยะลา",
    "gps": "6.61857,101.2373",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/6.61857,101.2373",
    "url": "https://streaming2.highwaytraffic.go.th/Phase18/PER_18_007.stream/playlist.m3u8"
  },
  {
    "name": "42-กอตอ - ปูต๊ะ",
    "detail": "42-กอตอ - ปูต๊ะ",
    "provine": "นราธิวาส",
    "gps": "6.40401,101.72104",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/6.40401,101.72104",
    "url": "https://streaming2.highwaytraffic.go.th/Phase18/PER_18_006.stream/playlist.m3u8"
  },
  {
    "name": "403 - อ.รัษฎา จ.ตรัง",
    "detail": "403 - อ.รัษฎา จ.ตรัง",
    "provine": "ตรัง",
    "gps": "7.93233,99.59759",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/7.93233,99.59759",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_033.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ.นาโยง จ.ตรัง",
    "detail": "4 - อ.นาโยง จ.ตรัง",
    "provine": "ตรัง",
    "gps": "7.5588,99.71867",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/7.5588,99.71867",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_027.stream/playlist.m3u8"
  },
  {
    "name": "419-ถนนแหวนรอบเมืองตรัง",
    "detail": "419-ถนนแหวนรอบเมืองตรัง",
    "provine": "ตรัง",
    "gps": "7.55063,99.58102",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/7.55063,99.58102",
    "url": "https://streaming2.highwaytraffic.go.th/Phase18/PER_18_003.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ.ทับปุด จ.พังงา",
    "detail": "4 - อ.ทับปุด จ.พังงา",
    "provine": "พังงา",
    "gps": "8.50871,98.65701",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/8.50871,98.65701",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_024.stream/playlist.m3u8"
  },
  {
    "name": "4 - เขาคราม - ตลาดเก่า",
    "detail": "4 - เขาคราม - ตลาดเก่า",
    "provine": "พังงา",
    "gps": "8.20333,98.81859",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/8.20333,98.81859",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_007.stream/playlist.m3u8"
  },
  {
    "name": "4 - เขาคราม - ตลาดเก่า",
    "detail": "4 - เขาคราม - ตลาดเก่า",
    "provine": "พังงา",
    "gps": "8.20333,98.81859",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/8.20333,98.81859",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_007.stream/playlist.m3u8"
  },
  {
    "name": "4-หนองหมู - ห้วยยาง",
    "detail": "4-หนองหมู - ห้วยยาง",
    "provine": "ประจวบคีรีขันธ์",
    "gps": "11.94478,99.82298",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/11.94478,99.82298",
    "url": "https://streaming2.highwaytraffic.go.th/Phase18/PER_18_001.stream/playlist.m3u8"
  },
  {
    "name": "37 - อ.ชะอำ จ.เพชรบุรี",
    "detail": "37 - อ.ชะอำ จ.เพชรบุรี",
    "provine": "เพชรบุรี",
    "gps": "12.74241,99.92924",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.74241,99.92924",
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_031.stream/playlist.m3u8"
  },
  {
    "name": "37 - อ.หัวหิน จ.ประจวบคีรีขันธ์",
    "detail": "37 - อ.หัวหิน จ.ประจวบคีรีขันธ์",
    "provine": "ประจวบคีรีขันธ์",
    "gps": "12.5311,99.8774",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.5311,99.8774",
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_028.stream/playlist.m3u8"
  },
  {
    "name": "33 - อ.ประจันตคาม จ.ปราจีนบุรี",
    "detail": "33 - อ.ประจันตคาม จ.ปราจีนบุรี",
    "provine": "ปราจีนบุรี",
    "gps": "14.06707,101.52801",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.06707,101.52801",
    "url": "https://streaming1.highwaytraffic.go.th/Phase5/PER_5_011.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ.บางสะพาน จ.ประจวบคีรีขันธ์",
    "detail": "4 - อ.บางสะพาน จ.ประจวบคีรีขันธ์",
    "provine": "ประจวบคีรีขันธ์",
    "gps": "11.20164,99.40258",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/11.20164,99.40258",
    "url": "https://streaming1.highwaytraffic.go.th/Phase5/PER_5_008.stream/playlist.m3u8"
  },
  {
    "name": "4-กระบุรี - หงาว",
    "detail": "4-กระบุรี - หงาว",
    "provine": "ระนอง",
    "gps": "10.01325,98.65598",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/10.01325,98.65598",
    "url": "https://streaming2.highwaytraffic.go.th/Phase18/PER_18_004.stream/playlist.m3u8"
  },
  {
    "name": "42 - ดอนยาง - บ้านดี",
    "detail": "42 - ดอนยาง - บ้านดี",
    "provine": "ปัตตานี",
    "gps": "6.8494,101.19404",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/6.8494,101.19404",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_013.stream/playlist.m3u8"
  },
  {
    "name": "4 - คลองบางดินสอ - นาเหนือ",
    "detail": "4 - คลองบางดินสอ - นาเหนือ",
    "provine": "พังงา",
    "gps": "8.06331,98.34",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/8.06331,98.34",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_008.stream/playlist.m3u8"
  },
  {
    "name": "402 - อ.ถลาง จ.ภูเก็ต",
    "detail": "ทางหลวงแผ่นดินหมายเลข 402 ระหว่าง กม. 23-24 ต.เทพกระษัตรี อ.ถลาง จ.ภูเก็ต",
    "provine": "ภูเก็ต",
    "gps": "8.06331,98.34",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/8.06331,98.34",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_032_OUT.stream/playlist.m3u8"
  },
  {
    "name": "4024 - อ.เมืองภูเก็ต จ.ภูเก็ต",
    "detail": "4024 - อ.เมืองภูเก็ต จ.ภูเก็ต",
    "provine": "ภูเก็ต",
    "gps": "7.92179,98.37072",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/7.92179,98.37072",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_038.stream/playlist.m3u8"
  },
  {
    "name": "108 - อ.เมืองเชียงใหม่ จ.เชียงใหม่",
    "detail": "ทางหลวงแผ่นดินหมายเลข 101 ระหว่าง กม. 7-8 ต.ป่าแดด อ.เมืองเชียงใหม่ จ.เชียงใหม่",
    "provine": "เชียงใหม่",
    "gps": "18.7469,98.96158",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.7469,98.96158",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_017_IN.stream/playlist.m3u8"
  },
  {
    "name": "107 - อ.แม่แตง จ.เชียงใหม่",
    "detail": "ทางหลวงแผ่นดินหมายเลข 107 ระหว่าง กม.41-42 ต.สันมหาพน อ.แม่แตง จ.เชียงใหม่",
    "provine": "เชียงใหม่",
    "gps": "19.12863,98.94854",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/19.12863,98.94854",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_032.stream/playlist.m3u8"
  },
  {
    "name": "108 - เชียงใหม่ - ปากทางท่าลี่",
    "detail": "ทางหลวงแผ่นดินหมายเลข 108 ระหว่าง กม 42 - 43 ",
    "provine": "เชียงใหม่",
    "gps": "18.48612,98.8052",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.48612,98.8052",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_001.stream/playlist.m3u8"
  },
  {
    "name": "11 - อุโมงค์ - รินคำ",
    "detail": "ทางหลวงแผ่นดินหมายเลข 11 ระหว่าง กม 559 - 560",
    "provine": "เชียงใหม่",
    "gps": "18.81158,98.99317",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.81158,98.99317",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_002_IN.stream/playlist.m3u8"
  },
  {
    "name": "121 - เหมืองกุง - ต้นเปา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 121 ระหว่าง กม 7 - 8",
    "provine": "เชียงใหม่",
    "gps": "18.72316,99.00965",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.72316,99.00965",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_003.stream/playlist.m3u8"
  },
  {
    "name": "12 - อ.แม่สอด จ.ตาก",
    "detail": "12 - อ.แม่สอด จ.ตาก",
    "provine": "เชียงใหม่",
    "gps": "16.72228,98.57363",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.72228,98.57363",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_029.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.เมืองตาก จังหวัดตาก",
    "detail": "1 - อ.เมืองตาก จังหวัดตาก",
    "provine": "เชียงใหม่",
    "gps": "16.77825,99.1626",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.77825,99.1626",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_004.stream/playlist.m3u8"
  },
  {
    "name": "121 - ต้นเปา - ดอนแก้ว",
    "detail": "ทางหลวงแผ่นดินหมายเลข 121 ระหว่าง กม 18 - 19",
    "provine": "เชียงใหม่",
    "gps": "18.79923,99.06406",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.79923,99.06406",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_004.stream/playlist.m3u8"
  },
  {
    "name": "305 - อ.องครักษ์ จ.นครนายก ทิศทางมุ่งหน้ากรุงเทพ",
    "detail": "ทางหลวงแผ่นดินหมายเลข 305 ระหว่าง กม.35-36 ต.บึงศาล อ.องค์รักษ์ จ.นครนายก",
    "provine": "นครนายก",
    "gps": "14.08821,100.92496",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.08821,100.92496",
    "url": "https://streaming1.highwaytraffic.go.th/Phase3/PER_3_013.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ.นครชัยศรี จ.นครปฐม ทิศทางมุ่งหน้าเข้า จังหวัดกรุงเทพฯ",
    "detail": "ทางหลวงแผ่นดินหมายเลข 4 ระหว่าง กม.45-46 ต.ศีรษะทอง อ.นครชัยศรี จ.นครปฐม ",
    "provine": "นครปฐม",
    "gps": "13.80528,100.1592",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase7/PER_7_035_IN.stream/playlist.m3u8"
  },
  {
    "name": "ถ.เพชรเกษม อ้อมใหญ่",
    "detail": "ถ.เพชรเกษม อ้อมใหญ่",
    "provine": "นครปฐม",
    "gps": "13.70799,100.28398",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.70799,100.28398",
    "url": "https://streaming1.highwaytraffic.go.th/Phase3/PER_3_004_IN.stream/playlist.m3u8"
  },
  {
    "name": "ถ.เพชรเกษม อ้อมใหญ่ ทิศทางมุ่งหน้าสามพราน",
    "detail": "ถ.เพชรเกษม อ้อมใหญ่ ทิศทางมุ่งหน้าสามพราน",
    "provine": "นครปฐม",
    "gps": "13.708211, 100.284074",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase3/PER_3_004_OUT.stream/playlist.m3u8"
  },
  {
    "name": "ถ.เพชรเกษม อ้อมใหญ่ ทิศทางมุ่งหน้าหนองแขม",
    "detail": "ถ.เพชรเกษม อ้อมใหญ่ ทิศทางมุ่งหน้าหนองแขม",
    "provine": "นครปฐม",
    "gps": "13.707995, 100.284116",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase3/PER_3_004_IN.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ้อมใหญ่ -นครชัยศรี IN ทิศทางมุ่งหน้าเข้า อ้อมใหญ่",
    "detail": "ทางหลวงแผ่นดินหมายเลข 4 ระหว่าง กม 28 - 29",
    "provine": "นครปฐม",
    "gps": "13.7118,100.26435",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.7118,100.26435",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_035_OUT.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ.เมืองนครปฐม จ.นครปฐม",
    "detail": "4 - อ.เมืองนครปฐม จ.นครปฐม",
    "provine": "นครปฐม",
    "gps": "13.79641,99.96177",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.79641,99.96177",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_012.stream/playlist.m3u8"
  },
  {
    "name": "เลี่ยงเมืองหน้าโฮมโปร มอเตอร์เวย์ สาย 6",
    "detail": "มอเตอร์เวย์ สาย 6",
    "provine": "นครราชสีมา",
    "gps": "14.98214,102.05256",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.98214,102.05256",
    "url": "https://streaming2.highwaytraffic.go.th/M6/M6_11.stream/playlist.m3u8"
  },
  {
    "name": "มอเตอร์เวย์ สาย 6-005",
    "detail": "จุดสำรวจปริมาณจราจร M6 (ช่วง อ.ปากช่อง - อ.สีคิ้ว ถนนมิตรภาพ หนองสาหร่าย ปากช่อง จ.นครราชสีมา 30130",
    "provine": "นครราชสีมา",
    "gps": "14.70449,101.48071",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.70449,101.48071",
    "url": "https://streaming2.highwaytraffic.go.th/M6/M6_5.stream/playlist.m3u8"
  },
  {
    "name": "มอเตอร์เวย์ สาย 6-011",
    "detail": "จุดสำรวจปริมาณจราจร M6 (ช่วง อ.สีคิ้ว - อ.ขามทะเลสอ)",
    "provine": "นครราชสีมา",
    "gps": "14.96668,101.85837",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.96668,101.85837",
    "url": "https://streaming2.highwaytraffic.go.th/M6/M6_7.stream/playlist.m3u8"
  },
  {
    "name": "290 - ถนนวงแหวนรอบเมืองนครราชสีมาด้านทิศใต้",
    "detail": "290 - ถนนวงแหวนรอบเมืองนครราชสีมาด้านทิศใต้",
    "provine": "นครราชสีมา",
    "gps": "14.87528,101.95493",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.87528,101.95493",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_011.stream/playlist.m3u8"
  },
  {
    "name": "แยก359 เขาหินซ้อน",
    "detail": "แยก359 เขาหินซ้อน",
    "provine": "นครราชสีมา",
    "gps": "13.78108122263965, 101.52561106106607",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.78108122263965,101.52561106106607",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD304KM127.stream/playlist.m3u8"
  },
  {
    "name": "ถนนมิตรภาพ อ.คง จ.นครราชสีมา (บ้านวัดแยกไปประทาย)",
    "detail": "ถนนมิตรภาพ อ.คง จ.นครราชสีมา (บ้านวัดแยกไปประทาย)",
    "provine": "นครราชสีมา",
    "gps": "15.3466,102.44476",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.3466,102.44476",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD2KM208.stream/playlist.m3u8"
  },
  {
    "name": "ถนนพหลโยธิน ต่างระดับบายพาสสระบุรี",
    "detail": "ถนนพหลโยธิน ต่างระดับบายพาสสระบุรี",
    "provine": "นครราชสีมา",
    "gps": "14.45297,100.9021",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.45297,100.9021",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD1KM99.stream/playlist.m3u8"
  },
  {
    "name": "พะโค - หนองสนวน",
    "detail": "พะโค - หนองสนวน",
    "provine": "นครราชสีมา",
    "gps": "14.54055,102.22658",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.54055,102.22658",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_006.stream/playlist.m3u8"
  },
  {
    "name": "304 - วังน้ําเขียว - ดอนขวาง",
    "detail": "ทางหลวงแผ่นดินหมายเลข 304 ระหว่าง กม 227 - 228 อ.วังน้ำเขียว จ.นครราชสีมา",
    "provine": "นครราชสีมา",
    "gps": "14.41141,101.86111",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.41141,101.86111",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_007.stream/playlist.m3u8"
  },
  {
    "name": "2 - มวกเหล็ก - บ่อทอง",
    "detail": "2 - มวกเหล็ก - บ่อทอง",
    "provine": "นครราชสีมา",
    "gps": "14.76123,101.51775",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.76123,101.51775",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_020_1.stream/playlist.m3u8"
  },
  {
    "name": "204 - อ.เมืองนครราชสีมา จ.นครราชสีมา",
    "detail": "204 - อ.เมืองนครราชสีมา จ.นครราชสีมา",
    "provine": "นครราชสีมา",
    "gps": "15.00419,102.05857",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.00419,102.05857",
    "url": "https: //streaming1.highwaytraffic.go.th/Phase6/PER_6_032.stream/playlist.m3u8"
  },
  {
    "name": "บ้านบุใหญ่ 2 - อ.เมืองนครราชสีมา จ.นครราชสีมา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 2 ระหว่าง กม. 122-123 อ.เมืองนครราชสีมา จ.นครราชสีมา ",
    "provine": "นครราชสีมา",
    "gps": "14.8937,101.88515",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.8937,101.88515",
    "url": "https://streaming2.highwaytraffic.go.th/Phase11/PER_11_007_IN.stream/playlist.m3u8"
  },
  {
    "name": "2422 - ทางเข้าปากช่อง ทิศทางมุ่งหน้าเข้า อ.ปากช่อง จ.นครราชสีมา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 2422 ระหว่าง กม 15 - 16",
    "provine": "นครราชสีมา",
    "gps": "14.74663,101.48723",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.74663,101.48723",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_021.stream/playlist.m3u8"
  },
  {
    "name": "มอเตอร์เวย์ สาย 6-003",
    "detail": "มอเตอร์เวย์ สาย 6-003",
    "provine": "นครราชสีมา",
    "gps": "14.68893,101.4681",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.68893,101.4681",
    "url": "https://streaming2.highwaytraffic.go.th/M6/M6_3.stream/playlist.m3u8"
  },
  {
    "name": "122 - ทางเลี่ยงเมืองนครสวรรค์ด้านตะวันตก",
    "detail": "122 - ทางเลี่ยงเมืองนครสวรรค์ด้านตะวันตก",
    "provine": "นครสวรรค์",
    "gps": "15.65168,100.07991",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.65168,100.07991",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_011_IN.stream/playlist.m3u8"
  },
  {
    "name": "1 - เกษตรชัย - ตาคลี",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1 ระหว่าง กม 251 - 252",
    "provine": "นครสวรรค์",
    "gps": "15.2798,100.37581",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.2798,100.37581",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_016.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.พยุหะคีรี จ.นครสวรรค์",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1ระหว่าง กม.308-309 ต.ท่าน้ำอ้อย อ.พยุหะคีรี จ.นครสวรรค์",
    "provine": "นครสวรรค์",
    "gps": "15.41188,100.14714",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.41188,100.14714",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_002_OUT.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.ตากฟ้า จ.นครสวรรค์",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1 ระหว่าง กม. 228-229 ต.สุขสำราญ อ.ตากฟ้า จ.นครสวรรค์",
    "provine": "นครสวรรค์",
    "gps": "15.34511,100.52628",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_002_IN.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/15.34511,100.52628"
  },
  {
    "name": "1 - บ้านหว้า - วังไผ่",
    "detail": "1 - บ้านหว้า - วังไผ่",
    "provine": "นครสวรรค์",
    "gps": "15.63568,100.13111",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_015_IN.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/15.63568,100.13111"
  },
  {
    "name": "1 - อ.บรรพตพิสัย จ.นครสวรรค์",
    "detail": "ทางหลวงแผ่นดินเหมายเลข 1 ระหว่าง กม. 384-385 ต.บางแก้ว อ.บรรพตพิสัย จ.นครสวรรค์",
    "provine": "นครสวรรค์",
    "gps": "15.95077,99.85199",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_013.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/15.95077,99.85199"
  },
  {
    "name": "334 - อ.เมืองอ่างทอง จ.อ่างทอง",
    "detail": "334 - อ.เมืองอ่างทอง จ.อ่างทอง",
    "provine": "อ่างทอง",
    "gps": "14.57883,100.47244",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.57883,100.47244",
    "url": "https://streaming2.highwaytraffic.go.th/Phase11/PER_11_017.stream/playlist.m3u8"
  },
  {
    "name": "334 - อ.เมืองอ่างทอง จ.อ่างทอง",
    "detail": "334 - อ.เมืองอ่างทอง จ.อ่างทอง",
    "provine": "อ่างทอง",
    "gps": "14.57883,100.47244",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.57883,100.47244",
    "url": "https://streaming2.highwaytraffic.go.th/Phase11/PER_11_017.stream/playlist.m3u8"
  },
  {
    "name": "ถนนพหลโยธิน ลงโทลเวย์-รังสิต",
    "detail": "ถนนพหลโยธิน ลงโทลเวย์-รังสิต",
    "provine": "ปทุมธานี",
    "gps": "14.00913,100.61539",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.00913,100.61539",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD1KM33.stream/playlist.m3u8"
  },
  {
    "name": "ทางหลวงแผ่นดินหมายเลข 32 ต.เสือโฮก อ.เมืองชัยนาท จ.ชัยนาท 17000",
    "detail": "ทางหลวงแผ่นดินหมายเลข 32 ต.เสือโฮก อ.เมืองชัยนาท จ.ชัยนาท 17000",
    "provine": "สิงห์บุรี",
    "gps": "15.230529, 100.208592",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase4/PER_4_012_IN.stream/playlist.m3u8"
  },
  {
    "name": "32 - อ.พรหมบุรี จ.สิงห์บุรี ทิศทางมุ่งหน้าเข้า จ.สิงห์บุรี",
    "detail": "32 - อ.พรหมบุรี จ.สิงห์บุรี ทิศทางมุ่งหน้าเข้า จ.สิงห์บุรี",
    "provine": "สิงห์บุรี",
    "gps": "14.849151, 100.444664",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.208:1935/Phase11/PER_11_018_OUT.stream/playlist.m3u8"
  },
  {
    "name": "11- อ.ตาครี จ.นครสวรรค์",
    "detail": "ทางหลวงแผ่นดินเหมายเลข 11 ระหว่าง กม. 11-12 ต.สร้อยทอง อ.ตาครี จ.นครสวรรค์ ทิศทางมุ่งหน้าเข้า จ.สิงห์บุรี",
    "provine": "นครสวรรค์",
    "gps": "15.12052,100.39547",
    "type": "ทางหลวง",
    "url": "http://180.180.242.207:1935/Phase10/PER_10_015.stream/playlist.m3u8"
  },
  {
    "name": "122 - ทางเลี่ยงเมืองนครสวรรค์",
    "detail": "ทางหลวงแผ่นดินหมายเลข 122 (ทางเลี่ยงเมืองนครสวรรค์ด้านทิศตะวันตก) ระหว่าง กม.7-8 ต.นครสวรรค์ตก อ.เมือง จ.นครสวรรค์",
    "provine": "นครสวรรค์",
    "gps": "15.65907,100.0706",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.65907,100.0706",
    "url": "https://streaming1.highwaytraffic.go.th/Phase4/PER_4_015.stream/playlist.m3u8"
  },
  {
    "name": "212 - ห้วยก้านเหลือง - ดงบัง",
    "detail": "212 - ห้วยก้านเหลือง - ดงบัง",
    "provine": "บึงกาฬ",
    "gps": "18.37021,103.63764",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.37021,103.63764",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_002.stream/playlist.m3u8"
  },
  {
    "name": "1 - ต่างระดับคลองหลวง - ประตูน้ำพระอินทร์",
    "detail": "1 - ต่างระดับคลองหลวง - ประตูน้ำพระอินทร์",
    "provine": "ปทุมธานี",
    "gps": "14.08517,100.61794",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.08517,100.61794",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_029_1.stream/playlist.m3u8"
  },
  {
    "name": "ป้อมตำรวจแยกสวนสมเด็จ#2",
    "detail": "ป้อมตำรวจแยกสวนสมเด็จ#2",
    "provine": "นนทบุรี",
    "gps": "13.940596, 100.542054",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8802.m3u8"
  },
  {
    "name": "ถ.กาญจนาภิเษก บางใหญ่ ทิศทางมุ่งหน้าบางบัวทอง",
    "detail": "ถ.กาญจนาภิเษก บางใหญ่ ทิศทางมุ่งหน้าบางบัวทอง",
    "provine": "นนทบุรี",
    "gps": "13.830173, 100.413147",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8802.m3u8"
  },
  {
    "name": "ถ.กาญจนาภิเษก บางใหญ่ ทิศทางมุ่งหน้าบางแค",
    "detail": "ถ.กาญจนาภิเษก บางใหญ่ ทิศทางมุ่งหน้าบางแค",
    "provine": "นนทบุรี",
    "gps": "13.829907, 100.413361",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8802.m3u8"
  },
  {
    "name": "212 - อ.เมืองมุกดาหาร จ.มุกดาหาร",
    "detail": "212 - อ.เมืองมุกดาหาร จ.มุกดาหาร",
    "provine": "มุกดาหาร",
    "gps": "16.45753,104.64482",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_014.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/16.45753,104.64482"
  },
  {
    "name": "103 - อ.ร้องกวาง จ.แพร่",
    "detail": "ทางหลวงแผ่นดินหมายเลข 103 ระหว่าง กม. 8-9 ต.แม่ยางร้อง",
    "provine": "แพร่",
    "gps": "18.34801,100.23033",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_017.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/18.34801,100.23033"
  },
  {
    "name": "101 - อ.เมืองน่าน จ.น่าน ทิศทางมุ่งหน้าเข้า จังหวัดแพร่",
    "detail": "ทางหลวงแผ่นดินหมายเลข 101 ระหว่าง กม.360-361 ต.ดู่ใต้ อ.เมืองน่าน จ.น่าน",
    "provine": "น่าน",
    "gps": "18.79809,100.7151",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_034.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/18.79809,100.7151"
  },
  {
    "name": "101 - อ.เมืองน่าน จ.น่าน ทิศทางมุ่งหน้าเข้า จังหวัดแพร่",
    "detail": "ทางหลวงแผ่นดินหมายเลข 101 ระหว่าง กม.360-361 ต.ดู่ใต้ อ.เมืองน่าน จ.น่าน",
    "provine": "น่าน",
    "gps": "18.72853,100.75407",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_031.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/18.72853,100.75407"
  },
  {
    "name": "ถนนกบินทร์บุรี-ปักธงชัย (วังน้ำเขียว)",
    "detail": "ถนนกบินทร์บุรี-ปักธงชัย (วังน้ำเขียว)",
    "provine": "นครราชสีมา",
    "gps": "14.36551,101.84258",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.36551,101.84258",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD304KM221.stream/playlist.m3u8"
  },
  {
    "name": "24 - อ.หนองบุญนาก จ.นครราชสีมา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 24 ระหว่าง กม.73-74 ต.หนองหัวแรต อ.หนองบุนนาก จ.นครราชสีมา",
    "provine": "นครราชสีมา",
    "gps": "14.74646,102.35041",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.74646,102.35041",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_031.stream/playlist.m3u8"
  },
  {
    "name": "2 - อ.ปากช่อง จ.นครราชสีมา",
    "detail": "2 - อ.ปากช่อง จ.นครราชสีมา",
    "provine": "นครราชสีมา",
    "gps": "14.63981,101.26974",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.63981,101.26974",
    "url": "https://streaming1.highwaytraffic.go.th/Phase4/PER_4_002_IN.stream/playlist.m3u8"
  },
  {
    "name": "2422 - ทางเข้าปากช่อง",
    "detail": "ทางหลวงแผ่นดินหมายเลข 2422 ระหว่าง กม 15 - 16",
    "provine": "นครราชสีมา",
    "gps": "14.74683,101.48666",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.74683,101.48666",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_021.stream/playlist.m3u8"
  },
  {
    "name": "32 - อ.บางปะหัน จ.อยุธยา ทิศทางมุ่งหน้า จ.อ่างทอง",
    "detail": "32 - อ.บางปะหัน จ.อยุธยา ทิศทางมุ่งหน้า จ.อ่างทอง",
    "provine": "อยุธยา",
    "gps": "14.523124, 100.507964",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.523124,100.507964",
    "url": "https://streaming1.highwaytraffic.go.th/Phase4/PER_4_023.stream/playlist.m3u8"
  },
  {
    "name": "34 - บางวัว - บางปะกง ทิศทางมุ่งหน้าเข้า ต.บางปะกง อ.บางปะกง",
    "detail": "34 - บางวัว - บางปะกง ทิศทางมุ่งหน้าเข้า ต.บางปะกง อ.บางปะกง",
    "provine": "กรุงเทพ",
    "gps": "13.480411, 101.001441",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.208:1935/Phase12/PER_12_026_IN.stream/playlist.m3u8"
  },
  {
    "name": "309 - อ.บางปะอิน จ.อยุธยา",
    "detail": "309 - อ.บางปะอิน จ.อยุธยา",
    "provine": "อยุธยา",
    "gps": "14.29923,100.65425",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase3/PER_3_014.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/14.29923,100.65425"
  },
  {
    "name": "347 - อ.บางปะอิน จ.อยุธยา ทิศทางมุ่งหน้ากรุงเทพ",
    "detail": "ทางหลวงแผ่นดินหมายเลข 347 ที่ กม.20 ต.บางกระสั้น อ.บางปะอิน จ.พระนครศรีอยุธยา",
    "provine": "อยุธยา",
    "gps": "14.18301,100.55709",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.19_8802.m3u8"
  },
  {
    "name": "32 - อ.บางปะอิน จ.พระนครศรีอยุธยา",
    "detail": "32 - อ.บางปะอิน จ.พระนครศรีอยุธยา",
    "provine": "อยุธยา",
    "gps": "14.2205,100.61022",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.2205,100.61022",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_013_OUT.stream/playlist.m3u8"
  },
  {
    "name": "33 - อ.นครหลวง จ.พระนครศรีอยุธยา",
    "detail": "33 - อ.นครหลวง จ.พระนครศรีอยุธยา",
    "provine": "อยุธยา",
    "gps": "14.46336,100.57134",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.46336,100.57134",
    "url": "https://streaming1.highwaytraffic.go.th/Phase9/PER_9_024.stream/playlist.m3u8"
  },
  {
    "name": "347 - อ.บางปะหัน จ.พระนครศรีอยุธยา",
    "detail": "347 - อ.บางปะหัน จ.พระนครศรีอยุธยา",
    "provine": "อยุธยา",
    "gps": "14.42367,100.53301",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.42367,100.53301",
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_024.stream/playlist.m3u8"
  },
  {
    "name": "32 - อยุธยา - นครหลวง",
    "detail": "32 - อยุธยา - นครหลวง",
    "provine": "อยุธยา",
    "gps": "14.43206,100.55018",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.43206,100.55018",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_026_1.stream/playlist.m3u8"
  },
  {
    "name": "37 - ต่างระดับเชียงราก - บางกระสั้น",
    "detail": "37 - ต่างระดับเชียงราก - บางกระสั้น",
    "provine": "อยุธยา",
    "gps": "14.26929,100.53168",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.26929,100.53168",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_017_IN.stream/playlist.m3u8"
  },
  {
    "name": "ทล.1 กม.52 ถนนพหลโยธิน บนต่างระดับบางปะอิน",
    "detail": "ทล.1 กม.52 ถนนพหลโยธิน บนต่างระดับบางปะอิน",
    "provine": "อยุธยา",
    "gps": "14.16691,100.6182",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.16691,100.6182",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD1KM52.stream/playlist.m3u8"
  },
  {
    "name": "ถนนเอเซีย ต่างระดับอินทร์บุรี",
    "detail": "ถนนเอเซีย ต่างระดับอินทร์บุรี",
    "provine": "อยุธยา",
    "gps": "15.04133,100.33401",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.04133,100.33401",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD32KM106.stream/playlist.m3u8"
  },
  {
    "name": "วงแหวนตะวันตก ต.เชียงรากน้อย จ.พระนครศรีอยุธยา (ลงด่วนบางปะอิน)",
    "detail": "วงแหวนตะวันตก ต.เชียงรากน้อย จ.พระนครศรีอยุธยา (ลงด่วนบางปะอิน)",
    "provine": "อยุธยา",
    "gps": "14.15135,100.55851",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.15135,100.55851",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD9KM79.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.วังน้อย จ.พระนครศรีอยุธยา ทิศทางมุ่งหน้ากรุงเทพ",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1 ระหว่าง กม.60-61 ต.ลำไทร อ.วังน้อย จ.พระนครศรีอยุธยา",
    "provine": "อยุธยา",
    "gps": "14.21438,100.68154",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.21438,100.68154",
    "url": "https://streaming1.highwaytraffic.go.th/Phase5/PER_5_001_IN.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.เมืองพะเยา จ.พะเยา",
    "detail": "1 - อ.เมืองพะเยา จ.พะเยา",
    "provine": "พะยา",
    "gps": "19.12498,99.90787",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/19.12498,99.90787",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_028.stream/playlist.m3u8"
  },
  {
    "name": "1021 - แม่ต๋ำ - บ้านใหม่ ทิศทางมุ่งหน้าเข้า อ.เมืองพะเยา จ.พะยา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1021 ระหว่าง กม 6 - 7",
    "provine": "พะยา",
    "gps": "19.15903,99.96632",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/19.15903,99.96632",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_005.stream/playlist.m3u8"
  },
  {
    "name": "21 - อ.เมืองเพชรบูรณ์ จ.เพชรบูรณ์",
    "detail": "ทางหลวงแผ่นดินหมายเลข 21 ระหว่าง กม.204-205 ต.วังชมภู อ.เมืองเพชรบูรณ์ จ.เพชรบูรณ์",
    "provine": "เพชรบูรณ์",
    "gps": "16.27928,101.0598",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_002.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/16.27928,101.0598"
  },
  {
    "name": "202 - อ.พยัคฆภูมิพิสัย จ.มหาสารคาม ทิศทางมุ่งหน้าเข้า อ.ประทาย จ.นครราชศรีมา",
    "detail": "ทางหลวงแผ่นดินเหมายเลข 202 ระหว่าง กม. 138-139 ต.ปะหลาน อ.พยัคฆภูมิพิสัย จ.มหาสารคาม ",
    "provine": "มหาสารคาม",
    "gps": "15.5083,103.18689",
    "type": "ทางหลวง",
    "url": "http://180.180.242.207:1935/Phase9/PER_9_010.stream/playlist.m3u8"
  },
  {
    "name": "IWZ-2-001",
    "detail": "IWZ-2-001",
    "provine": "ระยอง",
    "gps": "12.735582979917648, 101.07527382112427",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.735582979917648,101.07527382112427",
    "url": "https://streaming6.highwaytraffic.go.th/IWZ-Phase10/IWZ10_01.stream/playlist.m3u8"
  },
  {
    "name": "36 - มะขามคู่ - มาบข่า IN-OUT",
    "detail": "36 - มะขามคู่ - มาบข่า IN-OUT",
    "provine": "ระยอง",
    "gps": "12.80611,101.14494",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.80611,101.14494",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_016_IN.stream/playlist.m3u8"
  },
  {
    "name": "จุดไฟแดงแยกม่วงค่อม",
    "detail": "จุดไฟแดงแยกม่วงค่อม",
    "provine": "ลพบุรี",
    "gps": "15.07831,100.99799",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.07831,100.99799",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD21KM51.stream/playlist.m3u8"
  },
  {
    "name": "323 - อ.บ้านโป่ง จ.ราชบุรี",
    "detail": "ทางหลวงแผ่นดินหมายเลข 323 ระหว่าง กม.16-17 ต.ท่าผา อ.บ้านโป่ง จ.ราชบุรี",
    "provine": "ราชบุรี",
    "gps": "13.85533,99.8386",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.85533,99.8386",
    "url": "https://streaming1.highwaytraffic.go.th/Phase5/PER_5_021.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ.โพธาราม จ.ราชบุรี",
    "detail": "ทางหลวงแผ่นดินเหมายเลข 4 ระหว่าง กม. 73-74 ต.ดอนกระเบื้อง อ.โพธาราม จ.ราชบุรี",
    "provine": "ราชบุรี",
    "gps": "13.75606,99.92409",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.75606,99.92409",
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_032.stream/playlist.m3u8"
  },
  {
    "name": "127 - ทางเลี่ยงเมืองลำปาง",
    "detail": "127 - ทางเลี่ยงเมืองลำปาง",
    "provine": "ลำปาง",
    "gps": "18.25114,99.51884",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.25114,99.51884",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_005.stream/playlist.m3u8"
  },
  {
    "name": "414 - อ.หาดใหญ่ จ.สงขลา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 414 ระหว่าง กม. 12-13 ต.คลองแห อ.หาดใหญ่ จ.สงขลา",
    "provine": "สงขลา",
    "gps": "7.07057,100.4922",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/7.07057,100.4922",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_036.stream/playlist.m3u8"
  },
  {
    "name": "22 - อ.สว่างแดนดิน จ.สกลนคร",
    "detail": "22 - อ.สว่างแดนดิน จ.สกลนคร",
    "provine": "สกลนคร",
    "gps": "17.42596,103.60354",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.42596,103.60354",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_004.stream/playlist.m3u8"
  },
  {
    "name": "21 - อ.ภูเรือ จ.เลย",
    "detail": "21 - อ.ภูเรือ จ.เลย",
    "provine": "เลย",
    "gps": "17.44517,101.46693",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.44517,101.46693",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_003.stream/playlist.m3u8"
  },
  {
    "name": "1039 - ดงสันเงิน - ขามแดง",
    "detail": "1039 - ดงสันเงิน - ขามแดง",
    "provine": "ลำปาง",
    "gps": "18.31422,99.44287",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.31422,99.44287",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_006.stream/playlist.m3u8"
  },
  {
    "name": "11 - ขุนตาน - อุโมงค์",
    "detail": "11 - ขุนตาน - อุโมงค์",
    "provine": "ลำพูน",
    "gps": "18.54127,99.06653",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.54127,99.06653",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_007.stream/playlist.m3u8"
  },
  {
    "name": "11 - ขุนตาน - อุโมงค์ IN-OUT",
    "detail": "11 - ขุนตาน - อุโมงค์ IN-OUT",
    "provine": "ลำพูน",
    "gps": "18.62546,99.04874",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.62546,99.04874",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_008_IN.stream/playlist.m3u8"
  },
  {
    "name": "1 - แม่เชียงรายบน - ดอนไชย",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1 ระหว่าง กม 606 - 607 ถนนพหลโยธิน เถินบุรี เถิน จ.ลำปาง",
    "provine": "ลำปาง",
    "gps": "17.54703,99.19772",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.54703,99.19772",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_001.stream/playlist.m3u8"
  },
  {
    "name": "106 - อ.บ้านโฮ่ง จ.ลำพูน",
    "detail": "ทางหลวงแผ่นดินหมายเลข 106 ระหว่าง กม. 119-120 ต.เหล่ายาว อ.บ้านโฮ่ง จ.ลำพูน ",
    "provine": "ลำพูน",
    "gps": "18.35825,98.81026",
    "type": "ทางหลวง",
    "url": "http://180.180.242.207:1935/Phase8/PER_8_018.stream/playlist.m3u8"
  },
  {
    "name": "22 - สูงเนิน - ท่าแร่",
    "detail": "ทางหลวงแผ่นดินหมายเลข 22 ระหว่าง กม 159 - 160",
    "provine": "สกลนคร",
    "gps": "17.23197,104.10851",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.23197,104.10851",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_001.stream/playlist.m3u8"
  },
  {
    "name": "303 - ราษฎร์บูรณะ - พระสมุทรเจดีย์",
    "detail": "303 - ราษฎร์บูรณะ - พระสมุทรเจดีย์",
    "provine": "สมุทรปราการ",
    "gps": "13.6005,100.55928",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.6005,100.55928",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_015_IN.stream/playlist.m3u8"
  },
  {
    "name": "ถ.ศรีนครินทร์ กม.16",
    "detail": "ถ.ศรีนครินทร์ กม.16",
    "provine": "สมุทรปราการ",
    "gps": "13.62359,100.62473",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.62359,100.62473",
    "url": "https://streaming1.highwaytraffic.go.th/Phase3/PER_3_018.stream/playlist.m3u8"
  },
  {
    "name": "ถ.บางนา-บางปะกง กม.6",
    "detail": "ทางหลวงหมายเลข 34 (ถ.บางนา-บางปะกง) ระหว่าง กม.6-7 (ช่วง ถ.ศรีนครินทร์ - ถ.กาญจนาภิเษก)",
    "provine": "สมุทรปราการ",
    "gps": "13.66037,100.66279",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.66037,100.66279",
    "url": "https://streaming1.highwaytraffic.go.th/Phase3/PER_3_009_IN.stream/playlist.m3u8"
  },
  {
    "name": "บ้านระกาศ 34 - อ.บางบ่อ จ.สมุทรปราการ ทิศทางมุ่งหน้าเข้า เขตบางนา",
    "detail": "34 - อ.บางบ่อ จ.สมุทรปราการ ทิศทางมุ่งหน้าเข้า เขตบางนา",
    "provine": "สมุทรปราการ",
    "gps": "13.57925,100.868533",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.57925,100.868533",
    "url": "https://streaming2.highwaytraffic.go.th/Phase11/PER_11_031_IN.stream/playlist.m3u8"
  },
  {
    "name": "314 - บางตำหรุ - คลองด่าน",
    "detail": "314 - บางตำหรุ - คลองด่าน",
    "provine": "สมุทรปราการ",
    "gps": "13.49693,100.84919",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.49693,100.84919",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_012.stream/playlist.m3u8"
  },
  {
    "name": "33 - อ.วัฒนานคร จ.สระแก้ว",
    "detail": "33 - อ.วัฒนานคร จ.สระแก้ว",
    "provine": "สระแก้ว",
    "gps": "13.74856,102.30718",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.74856,102.30718",
    "url": "https://streaming1.highwaytraffic.go.th/Phase5/PER_5_012.stream/playlist.m3u8"
  },
  {
    "name": "บางนาตราดก่อนแยกศรีเอี่ยม",
    "detail": "บางนาตราดก่อนแยกศรีเอี่ยม",
    "provine": "สมุทรปราการ",
    "gps": "13.666487, 100.641050",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.21_8001.m3u8"
  },
  {
    "name": "แยกบางนาซอย 7",
    "detail": "แยกบางนาซอย 7",
    "provine": "สมุทรปราการ",
    "gps": "13.6730785630154, 100.60929341983248",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.21_8002.m3u8"
  },
  {
    "name": "แยกตลาดน้ำอัมพวา",
    "detail": "แยกตลาดน้ำอัมพวา",
    "provine": "สมุทรสงคราม",
    "gps": "13.3973,100.00408",
    "type": "ทางหลวง",
    "url": "http://180.180.242.207:1935/Interchange/ITC-014.stream/playlist.m3u8"
  },
  {
    "name": "35 - อ.เมือง จ.สมุทรสงคราม",
    "detail": "ทางหลวงแผ่นดินหมายเลข 35 ระหว่าง กม.72-73 ต.คลองโคน อ.เมือง จ.สมุทรสงคราม",
    "provine": "สมุทรสงคราม",
    "gps": "13.35735,99.93623",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.35735,99.93623",
    "url": "https://streaming1.highwaytraffic.go.th/Phase5/PER_5_014_IN.stream/playlist.m3u8"
  },
  {
    "name": "35 - อ.เมือง จ.สมุทรสงคราม 2",
    "detail": "ทางหลวงแผ่นดินหมายเลข 35 ระหว่าง กม.72-73 ต.คลองโคน อ.เมือง จ.สมุทรสงคราม",
    "provine": "สมุทรสงคราม",
    "gps": "13.35735,99.93623",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.35735,99.93623",
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_034_IN.stream/playlist.m3u8"
  },
  {
    "name": "สวนป่าพุทธมณฑล",
    "detail": "สวนป่าพุทธมณฑล",
    "provine": "สมุทรสาคร",
    "gps": "13.76419,100.18501",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.76419,100.18501",
    "url": "https://streaming1.highwaytraffic.go.th/Interchange/ITC-016.stream/playlist.m3u8"
  },
  {
    "name": "348 - อ.ตาพระยา จ.สระแก้ว",
    "detail": "ทางหลวงแผ่นดินหมายเลข 348 ระหว่าง กม. 74-75 ต.ทัพราช อ.ตาพระยา จ.สระแก้ว ",
    "provine": "สระแก้ว",
    "gps": "14.11306,102.67719",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.11306,102.67719",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_011.stream/playlist.m3u8"
  },
  {
    "name": "3ถนนเพรชเกษม แยกวังมะนาว",
    "detail": "ถนนเพรชเกษม แยกวังมะนาว",
    "provine": "ราชบุรี",
    "gps": "13.32829,99.82909",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.32829,99.82909",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD4KM123.stream/playlist.m3u8"
  },
  {
    "name": "อ.ตาพระยา จ.สระแก้ว (ตลาดโคกอีโด่ย)",
    "detail": "อ.ตาพระยา จ.สระแก้ว (ตลาดโคกอีโด่ย)",
    "provine": "สระแก้ว",
    "gps": "14.12099,102.67393",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.12099,102.67393",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD348KM75.stream/playlist.m3u8"
  },
  {
    "name": "2 - อ.หนองแค จ.สระบุรี ทิศทางออกจากกรุงเทพ",
    "detail": "2 - อ.หนองแค จ.สระบุรี ทิศทางออกจากกรุงเทพ",
    "provine": "สระบุรี",
    "gps": "14.391905, 100.887785",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase3/PER_3_003_OUT.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.หนองแค จ.สระบุรี ทิศทางมุ่งหน้ากรุงเทพ",
    "detail": "1 - อ.หนองแค จ.สระบุรี ทิศทางมุ่งหน้ากรุงเทพ",
    "provine": "สระบุรี",
    "gps": "14.391463, 100.887784",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase3/PER_3_003_IN.stream/playlist.m3u8"
  },
  {
    "name": "up / 1 - อ.วังน้อย จ.พระนครศรีอยุธยา ทิศทางมุ่งหน้าสระบุรี",
    "detail": "up / 1 - อ.วังน้อย จ.พระนครศรีอยุธยา ทิศทางมุ่งหน้าสระบุรี",
    "provine": "อยุธยา",
    "gps": "14.212739, 100.679832",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase5/PER_5_001_OUT.stream/playlist.m3u8"
  },
  {
    "name": "up / 2 - อ.วังน้อย จ.พระนครศรีอยุธยา ทิศทางมุ่งหน้ากรุงเทพ",
    "detail": "up / 2 - 1 - อ.วังน้อย จ.พระนครศรีอยุธยา ทิศทางมุ่งหน้ากรุงเทพ",
    "provine": "อยุธยา",
    "gps": "14.212383, 100.679638",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.207:1935/Phase5/PER_5_001_IN.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.หนองแค จ.สระบุรี",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1 ระหว่าง กม.92-93 ต.ห้วยขมิ้น อ.หนองแค จ.สระบุรี",
    "provine": "สระบุรี",
    "gps": "14.39114,100.88767",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.39114,100.88767",
    "url": "https://streaming1.highwaytraffic.go.th/Phase3/PER_3_003_IN.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.เฉลิมพระเกียรติ จ.สระบุรี",
    "detail": "1 - อ.เฉลิมพระเกียรติ จ.สระบุรี",
    "provine": "สระบุรี",
    "gps": "14.61087,100.89355",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.61087,100.89355",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER6001IN.stream/playlist.m3u8"
  },
  {
    "name": "ถนนมิตรภาพ (มวกเหล็ก)",
    "detail": "ถนนมิตรภาพ (มวกเหล็ก)",
    "provine": "สระบุรี",
    "gps": "14.63583,101.20453",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.63583,101.20453",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD2KM35.stream/playlist.m3u8"
  },
  {
    "name": "357 - ถนนวงแหวนรอบเมืองสุพรรณบุรี",
    "detail": "357 - ถนนวงแหวนรอบเมืองสุพรรณบุรี",
    "provine": "สุพรรณบุรี",
    "gps": "14.4823,100.17197",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_024.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/14.4823,100.17197"
  },
  {
    "name": "1 - ตาลเดี่ยว - ซับบอน ทิศทางมุ่งหน้าเข้า อ.ปากช่อง",
    "detail": "1 - ตาลเดี่ยว - ซับบอน ทิศทางมุ่งหน้าเข้า อ.ปากช่อง",
    "provine": "สระบุรี",
    "gps": "14.604712, 101.059424",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.208:1935/Phase12/PER_12_010_OUT.stream/playlist.m3u8"
  },
  {
    "name": "2 - ตาลเดี่ยว - ซับบอน ทิศทางมุ่งหน้าเข้า อ.เมืองสระบุรี",
    "detail": " 2 - ตาลเดี่ยว - ซับบอน ทิศทางมุ่งหน้าเข้า อ.เมืองสระบุรี",
    "provine": "สระบุรี",
    "gps": "14.604418, 101.059276",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/pass/180.180.242.208:1935/Phase12/PER_12_010_IN.stream/playlist.m3u8"
  },
  {
    "name": "2 - ตาลเดี่ยว - ซับบอน",
    "detail": "ทางหลวงแผ่นดินหมายเลข 2 ระหว่าง กม 17 - 18 อ.แก่งคอย จ.สระบุรี",
    "provine": "สระบุรี",
    "gps": "14.60476,101.06006",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.60476,101.06006",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_010_IN.stream/playlist.m3u8"
  },
  {
    "name": "210 - อ.เมืองหนองบัวลำภู จ.หนองบัวลำภู ",
    "detail": "ทางหลวงแผ่นดินเหมายเลข 210 ระหว่าง กม. 54-55 ต.นาคำไฮ อ.เมืองหนองบัวลำภู จ.หนองบัวลำภู ",
    "provine": "หนองบัวลำภู",
    "gps": "17.2664,102.33458",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.2664,102.33458",
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_006.stream/playlist.m3u8"
  },
  {
    "name": "230 - อ.เมืองขอนแก่น จ.ขอนแก่น",
    "detail": "230 - อ.เมืองขอนแก่น จ.ขอนแก่น",
    "provine": "ขอนแก่น",
    "gps": "16.45477,102.76826",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.45477,102.76826",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_033.stream/playlist.m3u8"
  },
  {
    "name": "35 - อ.เมือง จ.สมุทรสงคราม",
    "detail": "35 - อ.เมือง จ.สมุทรสงคราม",
    "provine": "สมุทรสงคราม",
    "gps": "13.41567,100.02889",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.41567,100.02889",
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_034_IN.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ.ปากท่อ จ.ราชบุรี",
    "detail": "4 - อ.ปากท่อ จ.ราชบุรี",
    "provine": "ราชบุรี",
    "gps": "13.41367,99.81079",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.41367,99.81079",
    "url": "https://streaming1.highwaytraffic.go.th/Phase10/PER_10_033.stream/playlist.m3u8"
  },
  {
    "name": "ก่อนถนนข้าวหลามมุ่งหน้าบางแสน(สุขุมวิท) 3 - อ.เมืองชลบุรี จ.ชลบุรี",
    "detail": "3 - อ.เมืองชลบุรี จ.ชลบุรี",
    "provine": "ชลบุรี",
    "gps": "13.29441,100.94376",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.29441,100.94376",
    "url": "https://streaming2.highwaytraffic.go.th/Phase11/PER_11_028_IN.stream/playlist.m3u8"
  },
  {
    "name": "32 - อ่างทอง - ไชโย",
    "detail": "ทางหลวงแผ่นดินหมายเลข 32 ระหว่าง กม 55 - 56 อ.ไชโย จ.อ่างทอง ",
    "provine": "อ่างทอง",
    "gps": "14.63178,100.47312",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.63178,100.47312",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_012_IN.stream/playlist.m3u8"
  },
  {
    "name": "2-โนนสะอาด - อุดรธานี",
    "detail": "2-โนนสะอาด - อุดรธานี",
    "provine": "อุดรธานี",
    "gps": "17.07877,102.93074",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.07877,102.93074",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_006.stream/playlist.m3u8"
  },
  {
    "name": "2 - อุดรธานี - น้ำสวย",
    "detail": "2 - อุดรธานี - น้ำสวย",
    "provine": "อุดรธานี",
    "gps": "17.32168,102.84508",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.32168,102.84508",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_013_1.stream/playlist.m3u8"
  },
  {
    "name": "22 - อ.เมืองอุดรธานี จ.อุดรธานี",
    "detail": "ทางหลวงแผ่นดินหมายเลข 22 ระหว่าง กม.9-10 ต.หนองขอนกว้าง อ.เมืองอุดรธานี จ.อุดรธานี",
    "provine": "อุดรธานี",
    "gps": "17.36244,102.87186",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.36244,102.87186",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_013_1.stream/playlist.m3u8"
  },
  {
    "name": "11-บ้านป่า - นาอิน",
    "detail": "11-บ้านป่า - นาอิน",
    "provine": "พิษณุโลก",
    "gps": "16.9367,100.34964",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.9367,100.34964",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_001.stream/playlist.m3u8"
  },
  {
    "name": "126 - ถนนวงแหวนรอบเมืองพิษณุโลกทิศใต้",
    "detail": "126 - ถนนวงแหวนรอบเมืองพิษณุโลกทิศใต้",
    "provine": "พิษณุโลก",
    "gps": "16.75865,100.23505",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.75865,100.23505",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_006.stream/playlist.m3u8"
  },
  {
    "name": "11 - สากเหล็ก - กกไม้แดง",
    "detail": "11 - สากเหล็ก - กกไม้แดง",
    "provine": "พิษณุโลก",
    "gps": "16.70234,100.43182",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.70234,100.43182",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_003.stream/playlist.m3u8"
  },
  {
    "name": "4 - อ.ชะอำ จ.เพชรบุรี",
    "detail": "4 - อ.ชะอำ จ.เพชรบุรี",
    "provine": "เพชรบุรี",
    "gps": "12.67375,99.9525",
    "type": "ทางหลวง",
    "urlweb": "https://app.teekhawat.com/12.67375,99.9525",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase5/PER_5_007_IN.stream/playlist.m3u8"
  },
  {
    "name": "4 - สระพระ - ห้วยทรายใต้",
    "detail": "4 - สระพระ - ห้วยทรายใต้",
    "provine": "เพชรบุรี",
    "gps": "12.89485,99.9107",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.89485,99.9107",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_033_1.stream/playlist.m3u8"
  },
  {
    "name": "สระกระเทียม",
    "detail": "สระกระเทียม",
    "provine": "เพชรบุรี",
    "gps": "13.79511,99.95507",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.79511,99.95507",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD4KM76.stream/playlist.m3u8"
  },
  {
    "name": "ถนนเพรชเกษม บายพาสชะอำ",
    "detail": "ถนนเพรชเกษม บายพาสชะอำ",
    "provine": "เพชรบุรี",
    "gps": "12.81419,99.94198",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.81419,99.94198",
    "url": "https://streaming7.highwaytraffic.go.th/HPL/HPL_RD4KM187.stream/playlist.m3u8"
  },
  {
    "name": "21-บุ่งน้ำเต้า - สักหลง",
    "detail": "21-บุ่งน้ำเต้า - สักหลง",
    "provine": "เพชรบูรณ์",
    "gps": "16.694,101.16838",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.694,101.16838",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_002.stream/playlist.m3u8"
  },
  {
    "name": "21 - อ.หล่มเก่า จ.เพชรบูรณ์",
    "detail": "21 - อ.หล่มเก่า จ.เพชรบูรณ์",
    "provine": "เพชรบูรณ์",
    "gps": "16.93798,101.21929",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.93798,101.21929",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_003.stream/playlist.m3u8"
  },
  {
    "name": "113 - ฆะมัง - พิจิตร",
    "detail": "ทางหลวงแผ่นดินหมายเลข 113 ระหว่าง กม 100 - 101 ",
    "provine": "พิจิตร",
    "gps": "16.38273,100.37384",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.38273,100.37384",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_004.stream/playlist.m3u8"
  },
  {
    "name": "117 - เนินสว่าง - หนองนา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 117 ระหว่าง กม 75 - 76",
    "provine": "พิจิตร",
    "gps": "16.37351,100.13214",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.37351,100.13214",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_005.stream/playlist.m3u8"
  },
  {
    "name": "แยกมอดินแดง ทิศใต้",
    "detail": "แยกมอดินแดง ทิศใต้",
    "provine": "ขอนแก่น",
    "gps": "16.477309, 102.832557",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk07.m3u8"
  },
  {
    "name": "ป้อมยามสามเหลี่ยม3",
    "detail": "ป้อมยามสามเหลี่ยม3",
    "provine": "ขอนแก่น",
    "gps": "16.439926, 102.828975",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk14.m3u8"
  },
  {
    "name": "แยกมอดินแดง ทิศเหนือ",
    "detail": "แยกมอดินแดง ทิศเหนือ",
    "provine": "ขอนแก่น",
    "gps": "16.477309, 102.832557",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk06.m3u8"
  },
  {
    "name": "ป้อมยามสามเหลี่ยม2",
    "detail": "ป้อมยามสามเหลี่ยม2",
    "provine": "ขอนแก่น",
    "gps": "16.439931, 102.829085",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk13.m3u8"
  },
  {
    "name": "แยก Central ทิศเหนือ",
    "detail": "แยก Central ทิศเหนือ",
    "provine": "ขอนแก่น",
    "gps": "16.432473, 102.823781",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk01.m3u8"
  },
  {
    "name": "แยก Central ทิศใต้",
    "detail": "แยก Central ทิศใต้",
    "provine": "ขอนแก่น",
    "gps": "16.432473, 102.823781",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk05.m3u8"
  },
  {
    "name": "แยก Central ทิศตะวันออก",
    "detail": "แยก Central ทิศตะวันออก",
    "provine": "ขอนแก่น",
    "gps": "16.432473, 102.823781",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk01.m3u8"
  },
  {
    "name": "แยก Central ทิศตะวันตก",
    "detail": "แยก Central ทิศตะวันตก",
    "provine": "ขอนแก่น",
    "gps": "16.432473, 102.823781",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk13.m3u8"
  },
  {
    "name": "NEU South",
    "detail": "NEU South",
    "provine": "ขอนแก่น",
    "gps": "16.432473, 102.823781",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk27.m3u8"
  },
  {
    "name": "NEU East",
    "detail": "NEU East",
    "provine": "ขอนแก่น",
    "gps": "16.432473, 102.823781",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk05.m3u8"
  },
  {
    "name": "NEU West",
    "detail": "NEU West",
    "provine": "ขอนแก่น",
    "gps": "16.432473, 102.823781",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk04.m3u8"
  },
  {
    "name": "แยกเจริญศรี ทิศตะวันออก",
    "detail": "แยกเจริญศรี ทิศตะวันออก",
    "provine": "ขอนแก่น",
    "gps": "16.414026, 102.818497",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk27.m3u8"
  },
  {
    "name": "แยกเจริญศรี ทิศตะวันตก",
    "detail": "แยกเจริญศรี ทิศตะวันตก",
    "provine": "ขอนแก่น",
    "gps": "16.414026, 102.818497",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk05.m3u8"
  },
  {
    "name": "แยกมะลิวัลย์",
    "detail": "แยกมะลิวัลย์",
    "provine": "ขอนแก่น",
    "gps": "16.440886, 102.819301",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk13.m3u8"
  },
  {
    "name": "แยกมะลิวัลย์ 2",
    "detail": "แยกมะลิวัลย์ 2 ",
    "provine": "ขอนแก่น",
    "gps": "16.441019, 102.818003",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk05.m3u8"
  },
  {
    "name": "KKU Miliwan East",
    "detail": "KKU Miliwan East",
    "provine": "ขอนแก่น",
    "gps": "16.441524, 102.815407",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk01.m3u8"
  },
  {
    "name": "KKU Miliwan West",
    "detail": "KKU Miliwan West",
    "provine": "ขอนแก่น",
    "gps": "16.441668, 102.813841",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk01.m3u8"
  },
  {
    "name": "แยกเจริญศรี ทิศใต้",
    "detail": "แยกเจริญศรี ทิศใต้",
    "provine": "ขอนแก่น",
    "gps": "16.414026, 102.818497",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/kk09.m3u8"
  },
  {
    "name": "บางนาตราดซอย 7",
    "detail": "บางนาตราดซอย 7",
    "provine": "กรุงเทพ",
    "gps": "13.669195, 100.628629",
    "type": "ทางหลวง",
    "url": "https://camera1.iticfoundation.org/hls/10.8.0.21_8002.m3u8"
  },
  {
    "name": "331 - แปลงยาว - เขาหินซ้อน",
    "detail": "331 - แปลงยาว - เขาหินซ้อน",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.60445,101.30347",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_032.stream/playlist.m3u8",
    "urlweb": "https://app.teekhawat.com/13.60445,101.30347"
  },
  {
    "name": "สามแยกถนนเทพคุณากร-ถนนสิริโสธร มุ่งหน้าเข้าจ.ฉะเชิงเทรา",
    "detail": "สามแยกถนนเทพคุณากร-ถนนสิริโสธร มุ่งหน้าเข้าจ.ฉะเชิงเทรา",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.666456, 101.049926",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs05.m3u8"
  },
  {
    "name": "จุดกลับรถโชคดีค้าไม้",
    "detail": "จุดกลับรถโชคดีค้าไม้",
    "provine": "ชลบุรี",
    "gps": "12.92392674377789, 100.89838700449256",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-001.m3u8"
  },
  {
    "name": "ซอยโพธิสาร 6",
    "detail": "CC-004_ซอยโพธิสาร 6",
    "provine": "ชลบุรี",
    "gps": "12.954680931281935, 100.90065068898568",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-004.m3u8"
  },
  {
    "name": "ตลาดด้านในชุมชนวัดชัยมงคล 2",
    "detail": "ตลาดด้านในชุมชนวัดชัยมงคล 2",
    "provine": "ชลบุรี",
    "gps": "12.926077664402143, 100.87649684909319",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/RC-732.m3u8"
  },
  {
    "name": "สี่แยกตันตรารักษ์",
    "detail": "สี่แยกตันตรารักษ์",
    "provine": "ชลบุรี",
    "gps": "12.942662826662982, 100.90102556441059",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-010.m3u8"
  },
  {
    "name": "สามแยกฮอลลีวูด ถนนเพ็ชรตระกูล",
    "detail": "สามแยกฮอลลีวูด ถนนเพ็ชรตระกูล",
    "provine": "ชลบุรี",
    "gps": "12.942910850528554, 100.89156423453791",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-014.m3u8"
  },
  {
    "name": "บริเวณวงเวียนปลาโลมา",
    "detail": "บริเวณวงเวียนปลาโลมา",
    "provine": "ชลบุรี",
    "gps": "12.951040966951368, 100.88736869192738",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-015.m3u8"
  },
  {
    "name": "016_บริเวณวงเวียนปลาโลมา",
    "detail": "016_บริเวณวงเวียนปลาโลมา",
    "provine": "ชลบุรี",
    "gps": "12.950444979085729, 100.88783003184676",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-016.m3u8"
  },
  {
    "name": "บริเวณ แยกพัทยากลาง – ถ.เฉลิมพระเกียรติ",
    "detail": "บริเวณ แยกพัทยากลาง – ถ.เฉลิมพระเกียรติ",
    "provine": "ชลบุรี",
    "gps": "12.933164772276145, 100.89667316230452",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-023.m3u8"
  },
  {
    "name": "ปากซอยเฉลิมพระเกียรติ 9ติ",
    "detail": "ปากซอยเฉลิมพระเกียรติ 9",
    "provine": "ชลบุรี",
    "gps": "12.938126044355817, 100.8933345968654",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-034.m3u8"
  },
  {
    "name": "046_ซอยพรประภานิมิตร",
    "detail": "046_ซอยพรประภานิมิตร",
    "provine": "ชลบุรี",
    "gps": "12.926440021995932, 100.95229865184167",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-034.m3u8"
  },
  {
    "name": "052_แยกสนามกอล์ฟเลียบทางรถไฟ",
    "detail": "052_แยกสนามกอล์ฟเลียบทางรถไฟ",
    "provine": "ชลบุรี",
    "gps": "12.935458591982115, 100.90749632955944",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-036.m3u8"
  },
  {
    "name": "พรประภานิมิตร1",
    "detail": "พรประภานิมิตร1",
    "provine": "ชลบุรี",
    "gps": "12.935636704483937, 100.90782210172279",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-046.m3u8"
  },
  {
    "name": "056_แยกเนินพลับหวานเลียบทางรถไฟ",
    "detail": "056_แยกเนินพลับหวานเลียบทางรถไฟ",
    "provine": "ชลบุรี",
    "gps": "12.931975495286604, 100.90565129653692",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-052.m3u8"
  },
  {
    "name": "058_เนินพลับหวาน",
    "detail": "058_เนินพลับหวาน",
    "provine": "ชลบุรี",
    "gps": "12.93209431206546, 100.90515943373059",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-058.m3u8"
  },
  {
    "name": "065_บริเวณ ถนนพัทยากลาง - ห้างสรรพสินค้า Power Buy",
    "detail": "065_บริเวณ ถนนพัทยากลาง - ห้างสรรพสินค้า Power Buy",
    "provine": "ชลบุรี",
    "gps": "12.933766390388804, 100.89478527640433",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-065.m3u8"
  },
  {
    "name": "353_แยกซอยเขาน้อยเลียบทางรถไฟ",
    "detail": "353_แยกซอยเขาน้อยเลียบทางรถไฟ",
    "provine": "ชลบุรี",
    "gps": "12.925576676374531, 100.90335172335074",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-353.m3u8"
  },
  {
    "name": "353_แยกซอยเขาน้อยเลียบทางรถไฟ",
    "detail": "353_แยกซอยเขาน้อยเลียบทางรถไฟ",
    "provine": "ชลบุรี",
    "gps": "12.925576676374531, 100.90335172335074",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/CC-353.m3u8"
  },
  {
    "name": "354_แยกซอยเขาน้อยเลียบทางรถไฟ",
    "detail": "54_แยกซอยเขาน้อยเลียบทางรถไฟ",
    "provine": "ชลบุรี",
    "gps": "12.925837484334167, 100.90261085270286",
    "type": "ทางหลวง",
    "url": "https: //stream2.ioc.pattaya.go.th/live/CC-353.m3u8"
  },
  {
    "name": "366_แยกมอเตอร์เวย์",
    "detail": "366_แยกมอเตอร์เวย์",
    "provine": "ชลบุรี",
    "gps": "12.94517786332986, 100.90446907970382",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-364.m3u8"
  },
  {
    "name": "373_แยกสุขุมวิท-พรประภานิมิตร",
    "detail": "373_แยกสุขุมวิท-พรประภานิมิตร",
    "provine": "ชลบุรี",
    "gps": "12.948620062850049, 100.90559684526079",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-366.m3u8"
  },
  {
    "name": "379_แยกพัทยกลาง-บิ๊กซีเอ็กตร้า",
    "detail": "379_แยกพัทยกลาง-บิ๊กซีเอ็กตร้า",
    "provine": "ชลบุรี",
    "gps": "12.93467204376228, 100.89220688199723",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-374.m3u8"
  },
  {
    "name": "069_บริเวณ ชายหาดพัทยา ซ.15",
    "detail": "069_บริเวณ ชายหาดพัทยา ซ.15",
    "provine": "ชลบุรี",
    "gps": "12.926859725835003, 100.8738985585163",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-376.m3u8"
  },
  {
    "name": "083_บริเวณ อาคารจอดรถแหลมบาลีฮาย",
    "detail": "083_บริเวณ อาคารจอดรถแหลมบาลีฮาย",
    "provine": "ชลบุรี",
    "gps": "12.925240973193365, 100.86745065033732",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-376.m3u8"
  },
  {
    "name": "084_บริเวณ อาคารจอดรถแหลมบาลีฮาย",
    "detail": "084_บริเวณ อาคารจอดรถแหลมบาลีฮาย",
    "provine": "ชลบุรี",
    "gps": "12.924810578081358, 100.86799917949976",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/CC-374.m3u8"
  },
  {
    "name": "086_ท่าเทียบเรือแหลมบาลีฮาย",
    "detail": "086_ท่าเทียบเรือแหลมบาลีฮาย",
    "provine": "ชลบุรี",
    "gps": "12.924595380248466, 100.86840626405987",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/SC-085.m3u8"
  },
  {
    "name": "078_บริเวณ หน้าโรงแรม LAGRILLAPE",
    "detail": "078_บริเวณ หน้าโรงแรม LAGRILLAPE",
    "provine": "ชลบุรี",
    "gps": "12.925357453017114, 100.87098085288721",
    "type": "ทางหลวง",
    "url": "https://stream2.ioc.pattaya.go.th/live/SC-078.m3u8"
  },
  {
    "name": "188_ตลาดใหม่นาเกลือ",
    "detail": "188_ตลาดใหม่นาเกลือ",
    "provine": "ชลบุรี",
    "gps": "12.969799968306553, 100.90724402337831",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/RC-188.m3u8"
  },
  {
    "name": "246_สี่แยกพัทยาเหนือ - สุขุมวิท SN02",
    "detail": "246_สี่แยกพัทยาเหนือ - สุขุมวิท SN02",
    "provine": "ชลบุรี",
    "gps": "12.948711021181655, 100.90547652532683",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/RC-032.m3u8"
  },
  {
    "name": "011_แยกไฟแดงหนองเกตุใหญ่",
    "detail": "011_แยกไฟแดงหนองเกตุใหญ่",
    "provine": "ชลบุรี",
    "gps": "12.98398090138082, 100.92056474931141",
    "type": "ทางหลวง",
    "url": "https://stream1.ioc.pattaya.go.th/live/RC-041.m3u8"
  },
  {
    "name": "สามแยกถนนเทพคุณากร-ถนนสิริโสธร มุ่งหน้าจ.ชลบุรี",
    "detail": "สามแยกถนนเทพคุณากร-ถนนสิริโสธร มุ่งหน้าจ.ชลบุรี",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.666018, 101.049886",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs03.m3u8"
  },
  {
    "name": "สามแยกถนนเทพคุณากร-ถนนสิริโสธร มุ่งหน้าถนนเทพคุณากร",
    "detail": "สามแยกถนนเทพคุณากร-ถนนสิริโสธร มุ่งหน้าถนนเทพคุณากร",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.666644, 101.050916",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs06.m3u8"
  },
  {
    "name": "สามแยกศรีโสธรตัดใหม่ ถนนมหาจักพรรดิ์",
    "detail": "สามแยกศรีโสธรตัดใหม่ – ถนนมหาจักพรรดิ์",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.694352, 101.063254",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs37.m3u8"
  },
  {
    "name": "สามแยกศรีโสธรตัดใหม่ - ถนนมหาจักพรรดิ์ 2 ",
    "detail": "สามแยกศรีโสธรตัดใหม่ - ถนนมหาจักพรรดิ์ 2 ",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.694253, 101.063823",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs36.m3u8"
  },
  {
    "name": "สามแยกเทศบาล – ถนนมหาจักพรรดิ์",
    "detail": "สามแยกเทศบาล – ถนนมหาจักพรรดิ์",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.692554, 101.071107",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs38.m3u8"
  },
  {
    "name": "ซอยทางเข้าจังหวัดฉะเชิงเทรา",
    "detail": "ซอยทางเข้าจังหวัดฉะเชิงเทรา",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.687555, 101.069584",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs42.m3u8"
  },
  {
    "name": "ถนนหน้าเมือง",
    "detail": "ถนนหน้าเมือง",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.684418, 101.066092",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs30.m3u8"
  },
  {
    "name": "หน้าโรงเรียนวัดโสธรวรารามวรวิหาร",
    "detail": " หน้าโรงเรียนวัดโสธรวรารามวรวิหาร",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.674105, 101.065113",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs30.m3u8"
  },
  {
    "name": "โค้งวัดโสธรวรารามวรวิหาร",
    "detail": "โค้งวัดโสธรวรารามวรวิหาร",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.674767, 101.068224",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs22.m3u8"
  },
  {
    "name": "วัดโสธรวรารามวรวิหาร",
    "detail": "วัดโสธรวรารามวรวิหาร",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.674627, 101.067929",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs23.m3u8"
  },
  {
    "name": "ถนนเอมอรอุทิศ 1",
    "detail": "ถนนเอมอรอุทิศ 1",
    "provine": "ฉะเชิงเทรา",
    "gps": "13.688392, 101.064295",
    "type": "ทางหลวง",
    "url": "https://camerai1.iticfoundation.org/hls/ccs19.m3u8"
  },
  {
    "name": "304-เขตมีนบุรี จ.กรุงเทพมหานครv",
    "detail": "304-เขตมีนบุรี จ.กรุงเทพมหานคร",
    "provine": "กรุงเทพ",
    "gps": "13.81341,100.77965",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.81341,100.77965",
    "url": "https://streaming1.highwaytraffic.go.th/Phase9/PER_9_027_IN.stream/playlist.m3u8"
  },
  {
    "name": "323 - ท่าเรือ - ท่าน้ำตื้น",
    "detail": "323 - ท่าเรือ - ท่าน้ำตื้น",
    "provine": "กาญจนบุรี",
    "gps": "13.97672,99.54712",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.97672,99.54712",
    "url": "https: //streaming2.highwaytraffic.go.th/Phase13/PER_13_025.stream/playlist.m3u8"
  },
  {
    "name": "101 - นครชุม - น้ำดิบ",
    "detail": "101 - นครชุม - น้ำดิบ",
    "provine": "กำแพงเพชร",
    "gps": "16.575,99.51004",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.575,99.51004",
    "url": "https://streaming2.highwaytraffic.go.th/P16/PER_16_009.stream/playlist.m3u8"
  },
  {
    "name": "112 - ทางเลี่ยงเมืองกำแพงเพชร",
    "detail": "112 - ทางเลี่ยงเมืองกำแพงเพชร",
    "provine": "กำแพงเพชร",
    "gps": "16.46309,99.54163",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.46309,99.54163",
    "url": "https: //streaming2.highwaytraffic.go.th/P16/PER_16_010.stream/playlist.m3u8"
  },
  {
    "name": "12 - สี่แยกสมเด็จ - คำพอก",
    "detail": "12 - สี่แยกสมเด็จ - คำพอก",
    "provine": "กาฬสินธุ์",
    "gps": "16.51115,104.16962",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.51115,104.16962",
    "url": "https: //streaming2.highwaytraffic.go.th/Phase13/PER_13_009.stream/playlist.m3u8"
  },
  {
    "name": "ถ.กาญจนาภิเษก บางแค",
    "detail": "ถ.กาญจนาภิเษก บางแค",
    "provine": "กรุงเทพ",
    "gps": "13.73872,100.40405",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.73872,100.40405",
    "url": "https://streaming1.highwaytraffic.go.th/Phase3/PER_3_005_OUT.stream/playlist.m3u8"
  },
  {
    "name": "401 - อ.พุนพิน จ.สุราษฎร์ธานี",
    "detail": "401 - อ.พุนพิน จ.สุราษฎร์ธานี",
    "provine": "สุราษฎร์ธานี",
    "gps": "9.037,99.07763",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/9.037,99.07763",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_030.stream/playlist.m3u8"
  },
  {
    "name": "420 - วงแหวนรอบเมืองสุราษฎร์ธานี",
    "detail": "ทางหลวงแผ่นดินหมายเลข 420 ระหว่าง กม 17 - 180",
    "provine": "สุราษฎร์ธานี",
    "gps": "9.13532,99.24911",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/9.13532,99.24911",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_003.stream/playlist.m3u8"
  },
  {
    "name": "44 - ท่าเรือ - หินโงก",
    "detail": "44 - ท่าเรือ - หินโงก",
    "provine": "สุราษฎร์ธานี",
    "gps": "9.09464,99.43863",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/9.09464,99.43863",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_004_OUT.stream/playlist.m3u8"
  },
  {
    "name": "4009 - บางใหญ่-ซอยสิบ",
    "detail": "4009 - บางใหญ่-ซอยสิบ",
    "provine": "สุราษฎร์ธานี",
    "gps": "9.04921,99.36241",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/9.04921,99.36241",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_005.stream/playlist.m3u8"
  },
  {
    "name": "4142 - บ้านใน - บ้านโฉ",
    "detail": "4142 - บ้านใน - บ้านโฉ",
    "provine": "สุราษฎร์ธานี",
    "gps": "9.23428,99.69475",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/9.23428,99.69475",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_006.stream/playlist.m3u8"
  },
  {
    "name": "4 - พรุพ้อ - เนินพิชัย",
    "detail": "4 - พรุพ้อ - เนินพิชัย",
    "provine": "สงขลา",
    "gps": "7.12065,100.3196",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/7.12065,100.3196",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_010.stream/playlist.m3u8"
  },
  {
    "name": "408 - ทุ่งหวัง - นาทวี",
    "detail": "408 - ทุ่งหวัง - นาทวี",
    "provine": "สงขลา",
    "gps": "7.00345,100.67219",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/7.00345,100.67219",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_012.stream/playlist.m3u8"
  },
  {
    "name": "1 - อ.สบปราบ จ.ลำปาง",
    "detail": "1 - อ.สบปราบ จ.ลำปาง",
    "provine": "ลำปาง",
    "gps": "17.8617,99.31795",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/17.8617,99.31795",
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_014.stream/playlist.m3u8"
  },
  {
    "name": "11 - อ.ห้างฉัตร จ.ลำปาง",
    "detail": "11 - อ.ห้างฉัตร จ.ลำปาง",
    "provine": "ลำปาง",
    "gps": "18.3076,99.39228",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/18.3076,99.39228",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_009.stream/playlist.m3u8"
  },
  {
    "name": "219 - สตึก - หัวถนน",
    "detail": "219 - สตึก - หัวถนน",
    "provine": "บุรีรัมย์",
    "gps": "15.07875,103.1654",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.07875,103.1654",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_008.stream/playlist.m3u8"
  },
  {
    "name": "406 - ปากจ่า - ค่ายรวมมิตร",
    "detail": "406 - ปากจ่า - ค่ายรวมมิตร",
    "provine": "สงขลา",
    "gps": "7.04979,100.16407",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/7.04979,100.16407",
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_016.stream/playlist.m3u8"
  },
  {
    "name": "4006 - ราชกรูด-วังตะกอ",
    "detail": "4006 - ราชกรูด-วังตะกอ",
    "provine": "ชุมพร",
    "gps": "9.97798,99.04261",
    "type": "ทางหลวง",
    "urlweb": "https://app.teekhawat.com/9.97798,99.04261",
    "streamfromweb": true,
    "url": "https://streaming2.highwaytraffic.go.th/Phase14/PER_14_009.stream/playlist.m3u8"
  },
  {
    "name": "408-หัวถนน - เฉลิมพระเกียรติ",
    "detail": "408-หัวถนน - เฉลิมพระเกียรติ",
    "provine": "นครศรีธรรมราช",
    "gps": "8.2752,100.00039",
    "type": "ทางหลวง",
    "urlweb": "https://app.teekhawat.com/8.2752,100.00039",
    "streamfromweb": true,
    "url": "https://streaming2.highwaytraffic.go.th/Phase18/PER_18_002.stream/playlist.m3u8"
  },
  {
    "name": "401 - อ.สิชล จ.นครศรีธรรมราช",
    "detail": "401 - อ.สิชล จ.นครศรีธรรมราช",
    "provine": "นครศรีธรรมราช",
    "gps": "8.9585,99.89439",
    "type": "ทางหลวง",
    "urlweb": "https://app.teekhawat.com/8.9585,99.89439",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase8/PER_8_031.stream/playlist.m3u8"
  },
  {
    "name": "41 - อ.จุฬาภรณ์ จ.นครศรีธรรมราช",
    "detail": "41 - อ.จุฬาภรณ์ จ.นครศรีธรรมราช",
    "provine": "นครศรีธรรมราช",
    "gps": "8.07062,99.8901",
    "type": "ทางหลวง",
    "urlweb": "https://app.teekhawat.com/8.07062,99.8901",
    "streamfromweb": true,
    "url": "https://streaming1.highwaytraffic.go.th/Phase5/PER_5_019.stream/playlist.m3u8"
  },
  {
    "name": "3249 - เขาไร่ยา - แพร่งขาหยั่ง",
    "detail": "3249 - เขาไร่ยา - แพร่งขาหยั่ง",
    "provine": "จันทบุรี",
    "gps": "12.76091,102.05475",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.76091,102.05475",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_025.stream/playlist.m3u8"
  },
  {
    "name": "217 - อ.สิรินธร จ.อุบลราชธานี",
    "detail": "217 - อ.สิรินธร จ.อุบลราชธานี",
    "provine": "อุบลราชธานี",
    "gps": "15.20121,105.38275",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.20121,105.38275",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_019.stream/playlist.m3u8"
  },
  {
    "name": "2050 - อ.เมืองอุบลราชธานี จ.อุบลราชธานี",
    "detail": "ทางหลวงแผ่นดินหมายเลข 2050 ระหว่าง กม.6-7 ต.ไร่น้อย อ.เมืองอุบลราชธานี จ.อุบลราชธานี",
    "provine": "อุบลราชธานี",
    "gps": "15.29892,104.89214",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.29892,104.89214",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_025.stream/playlist.m3u8"
  },
  {
    "name": "212 - อ.เมืองอุบลราชธานี จ.อุบลราชธานี",
    "detail": "ทางหลวงแผ่นดินหมายเลข 212 ระหว่าง กม.572-573 ต.ขี้เหล็ก อ.เมืองอุบลราชธานี จ.อุบลราชธานี",
    "provine": "อุบลราชธานี",
    "gps": "15.34602,104.82665",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.34602,104.82665",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_017.stream/playlist.m3u8"
  },
  {
    "name": "23 - เขื่อนใน - อุบลราชธานี",
    "detail": "23 - เขื่อนใน - อุบลราชธานี",
    "provine": "อุบลราชธานี",
    "gps": "15.32906,104.71181",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.32906,104.71181",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_017.stream/playlist.m3u8"
  },
  {
    "name": "บ้านบุ่งหวาย 226 - อ.วารินชำราบ จ.อุบลราชธานี",
    "detail": "บ้านบุ่งหวาย 226 - อ.วารินชำราบ จ.อุบลราชธานี",
    "provine": "อุบลราชธานี",
    "gps": "15.15407,104.76696",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.15407,104.76696",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_023.stream/playlist.m3u8"
  },
  {
    "name": "บ้านศรีไค 24 - อ.วารินชำราบ จ.อุบลราชธานี",
    "detail": "บ้านศรีไค 24 - อ.วารินชำราบ จ.อุบลราชธานี",
    "provine": "อุบลราชธานี",
    "gps": "15.10701,104.9014",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.10701,104.9014",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_007.stream/playlist.m3u8"
  },
  {
    "name": "202-โนนชัยศรี - บ้านบ่อ",
    "detail": "202-โนนชัยศรี - บ้านบ่อ ",
    "provine": "ร้อยเอ็ด",
    "gps": "15.75128,104.0419",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.75128,104.0419",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_008.stream/playlist.m3u8"
  },
  {
    "name": "2169 - ยโสธร - กุดชุม ทิศทางมุ่งหน้าเข้า ยโสธร",
    "detail": "ทางหลวงแผ่นดินหมายเลข 2169 ระหว่าง กม 4 - 5",
    "provine": "ยโสธร",
    "gps": "15.83693,104.15683",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.83693,104.15683",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_016.stream/playlist.m3u8"
  },
  {
    "name": "202-ยโสธร - สะพานคลองลำเซ",
    "detail": "202-ยโสธร - สะพานคลองลำเซ ",
    "provine": "ยโสธร",
    "gps": "15.79225,104.23141",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.79225,104.23141",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_009.stream/playlist.m3u8"
  },
  {
    "name": "215 - อ.เมืองสรวง จ.ร้อยเอ็ด",
    "detail": "215 - อ.เมืองสรวง จ.ร้อยเอ็ด",
    "provine": "ร้อยเอ็ด",
    "gps": "15.78346,103.72828",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.78346,103.72828",
    "url": "https://streaming1.highwaytraffic.go.th/Phase9/PER-9-013.stream/playlist.m3u8"
  },
  {
    "name": "202-โนนชัยศรี - บ้านบ่อ",
    "detail": "202-โนนชัยศรี - บ้านบ่อ",
    "provine": "ร้อยเอ็ด",
    "gps": "15.75785,104.04948",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.75785,104.04948",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_008.stream/playlist.m3u8"
  },
  {
    "name": "อ.จตุรพักตรพิมาน จ.ร้อยเอ็ด",
    "detail": "อ.จตุรพักตรพิมาน จ.ร้อยเอ็ด",
    "provine": "ร้อยเอ็ด",
    "gps": "15.87217,103.58498",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.87217,103.58498",
    "url": "https://streaming1.highwaytraffic.go.th/Phase9/PER-9-012.stream/playlist.m3u8"
  },
  {
    "name": "23 - อ.เสลภูมิ จ.ร้อยเอ็ด",
    "detail": "23 - อ.เสลภูมิ จ.ร้อยเอ็ด ",
    "provine": "ร้อยเอ็ด",
    "gps": "16.03187,103.93547",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.03187,103.93547",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_005.stream/playlist.m3u8"
  },
  {
    "name": "292-ทางเลี่ยงเมืองยโสธร",
    "detail": "292-ทางเลี่ยงเมืองยโสธร ",
    "provine": "ยโสธร",
    "gps": "15.79886,104.16824",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.79886,104.16824",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_010.stream/playlist.m3u8"
  },
  {
    "name": "212-อำนาจเจริญ - ลืออำนาจ",
    "detail": "212-อำนาจเจริญ - ลืออำนาจ",
    "provine": "อำนาจเจริญ",
    "gps": "15.80811,104.6283",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.80811,104.6283",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_014_IN.stream/playlist.m3u8"
  },
  {
    "name": "220-ศรีสะเกษ - วังหิน",
    "detail": "220-ศรีสะเกษ - วังหิน",
    "provine": "ศรีสะเกษ",
    "gps": "14.99512,104.22403",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.99512,104.22403",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_012.stream/playlist.m3u8"
  },
  {
    "name": "294-ทางเลี่ยงเมืองศรีสะเกษ",
    "detail": "294-ทางเลี่ยงเมืองศรีสะเกษ",
    "provine": "ศรีสะเกษ",
    "gps": "15.09467,104.30077",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.09467,104.30077",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_013_IN.stream/playlist.m3u8"
  },
  {
    "name": "224 - อ.โชคชัย จ.นครราชสีมา",
    "detail": "224 - อ.โชคชัย จ.นครราชสีมา",
    "provine": "นครราชสีมา",
    "gps": "14.85587,102.19088",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.85587,102.19088",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_020.stream/playlist.m3u8"
  },
  {
    "name": "304 - อ.ปักธงชัย จ.นครราชสีมา",
    "detail": "304 - อ.ปักธงชัย จ.นครราชสีมา",
    "provine": "นครราชสีมา",
    "gps": "14.78185,102.04102",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.78185,102.04102",
    "url": "https://streaming1.highwaytraffic.go.th/Phase6/PER_6_034.stream/playlist.m3u8"
  },
  {
    "name": "226 - อ.เมืองนครราชสีมา จ.นครราชสีมา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 226 ระหว่าง กม.6-7 ต.มะเริง อ.เมืองนครราชสีมา จ.นครราชสีมา",
    "provine": "นครราชสีมา",
    "gps": "14.98102,102.16727",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.98102,102.16727",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_022.stream/playlist.m3u8"
  },
  {
    "name": "205 - อ.เมืองนครราชสีมา จ.นครราชสีมา",
    "detail": "ทางหลวงแผ่นดินหมายเลข 205 ระหว่าง กม.221-222 ต.โคกสูง อ.เมืองนครราชสีมา จ.นครราชสีมา",
    "provine": "นครราชสีมา",
    "gps": "15.07171,102.11878",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.07171,102.11878",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_010.stream/playlist.m3u8"
  },
  {
    "name": "ด่านหินกอง กม.33+100",
    "detail": "ด่านหินกอง กม.33+100",
    "provine": "นครราชสีมา",
    "gps": "14.41423,100.83389",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.41423,100.83389",
    "url": "https://streaming2.highwaytraffic.go.th/M6/M6_9.stream/playlist.m3u8"
  },
  {
    "name": "201 - ทางต่างระดับสีคิ้ว - หินหล่อง",
    "detail": "ทางหลวงแผ่นดินหมายเลข 201 ระหว่าง กม 35 - 36",
    "provine": "นครราชสีมา",
    "gps": "15.17072,101.73906",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.17072,101.73906",
    "url": "https://streaming2.highwaytraffic.go.th/Phase13/PER_13_022.stream/playlist.m3u8"
  },
  {
    "name": "24 - ซับประดู่ - สี่แยกปักธงชัย",
    "detail": "24 - ซับประดู่ - สี่แยกปักธงชัย",
    "provine": "นครราชสีมา",
    "gps": "14.83728,101.76979",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.83728,101.76979",
    "url": "https://streaming2.highwaytraffic.go.th/Phase15/PER_15_012.stream/playlist.m3u8"
  },
  {
    "name": "362 - อ.เมืองสระบุรี จ.สระบุรี",
    "detail": "362 - อ.เมืองสระบุรี จ.สระบุรี",
    "provine": "สระบุรี",
    "gps": "14.49975,100.96942",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.49975,100.96942",
    "url": "https://streaming2.highwaytraffic.go.th/Phase11/PER_11_015.stream/playlist.m3u8"
  },
  {
    "name": "3111 - ท้ายเกาะ - เสนา",
    "detail": "3111 - ท้ายเกาะ - เสนา",
    "provine": "อยุธยา",
    "gps": "14.13766,100.494",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.13766,100.494",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_019.stream/playlist.m3u8"
  },
  {
    "name": "1 - ประตูน้ําพระอินทร์ - หนองแค",
    "detail": "ทางหลวงแผ่นดินหมายเลข 1 ระหว่าง กม 73 - 74 อ.วังน้อย จ.พระนครศรีอยุธยา ",
    "provine": "อยุธยา",
    "gps": "14.2653,100.78497",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.2653,100.78497",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_018_OUT.stream/playlist.m3u8"
  },
  {
    "name": "352 - อ.คลองหลวง จ.ปทุมธานี",
    "detail": "352 - อ.คลองหลวง จ.ปทุมธานี",
    "provine": "ปทุมธานี",
    "gps": "14.14124,100.74566",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/14.14124,100.74566",
    "url": "https://streaming1.highwaytraffic.go.th/Phase9/PER_9_029.stream/playlist.m3u8"
  },
  {
    "name": "331 - อ.บ้านบึง จ.ชลบุรี",
    "detail": "331 - อ.บ้านบึง จ.ชลบุรี",
    "provine": "ชลบุรี",
    "gps": "13.27662,101.25386",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.27662,101.25386",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_037.stream/playlist.m3u8"
  },
  {
    "name": "205-ช่องสำราญ - คำปิง",
    "detail": "205-ช่องสำราญ - คำปิง",
    "provine": "ชัยภูมิ",
    "gps": "15.40569,101.63521",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.40569,101.63521",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_005.stream/playlist.m3u8"
  },
  {
    "name": "201 - อ.เมืองชัยภูมิ จ. ชัยภูมิ",
    "detail": "201 - อ.เมืองชัยภูมิ จ. ชัยภูมิ",
    "provine": "ชัยภูมิ",
    "gps": "15.72592,102.0193",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/15.72592,102.0193",
    "url": "https://streaming1.highwaytraffic.go.th/Phase7/PER_7_008.stream/playlist.m3u8"
  },
  {
    "name": "3138 - บ้านบึง - มาบปู",
    "detail": "3138 - บ้านบึง - มาบปู",
    "provine": "ชลบุรี",
    "gps": "13.21035,101.15552",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.21035,101.15552",
    "url": "https://streaming2.highwaytraffic.go.th/Phase12/PER_12_020.stream/playlist.m3u8"
  },
  {
    "name": "0102-หนองรี - หนองปรือ",
    "detail": "0102-หนองรี - หนองปรือ",
    "provine": "ชลบุรี",
    "gps": "13.25406,101.20374",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.25406,101.20374",
    "url": "https://streaming2.highwaytraffic.go.th/Phase18/PER_18_008.stream/playlist.m3u8"
  },
  {
    "name": "331 - อ.บางละมุง จ.ชลบุรี",
    "detail": "331 - อ.บางละมุง จ.ชลบุรี",
    "provine": "ชลบุรี",
    "gps": "12.84135,101.01138",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/12.84135,101.01138",
    "url": "https://streaming2.highwaytraffic.go.th/Phase11/PER_11_030.stream/playlist.m3u8"
  },
  {
    "name": "3466-บ้านเก่า - พานทอง",
    "detail": "3466-บ้านเก่า - พานทอง",
    "provine": "ชลบุรี",
    "gps": "13.45935,101.06978",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/13.45935,101.06978",
    "url": "https://streaming2.highwaytraffic.go.th/Phase-17/PER_17_018.stream/playlist.m3u8"
  },
  {
    "name": "213 - อ.ภูพาน จ.สกลนคร ",
    "detail": "213 - อ.ภูพาน จ.สกลนคร ",
    "provine": "สกลนคร",
    "gps": "16.86829,103.93307",
    "type": "ทางหลวง",
    "streamfromweb": true,
    "urlweb": "https://app.teekhawat.com/16.86829,103.93307",
    "url": "https://streaming1.highwaytraffic.go.th/Phase9/PER_9_008.stream/playlist.m3u8"
  },
  {
    "name": "กรมหลวงประจักษ์ฝั่งหน้าป้อมตำรวจ",
    "detail": "กรมหลวงประจักษ์",
    "provine": "อุดรธานี",
    "gps": "17.40079107454253, 102.79477422665569",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/cctv_121.stream/playlist.m3u8"
  },
  {
    "name": "หน้าเคเอฟซี แยกหน้าสถานีรถไฟอุดรธานี",
    "detail": "วัฒนานุวงศ์ ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.40411786746106, 102.80421650173402",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_33.stream/playlist.m3u8"
  },
  {
    "name": "ถนนประจักษ์แยกหน้าสถานีรถไฟอุดรธานี",
    "detail": "วัฒนานุวงศ์ ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.40411786746106, 102.80421650173402",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_34.stream/playlist.m3u8"
  },
  {
    "name": "สี่แยกคอกม้าอุดร",
    "detail": "CQ5F+MR9 ตำบล บ้านเลื่อม อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.40932415248318, 102.77490670617573",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_52.stream/playlist.m3u8"
  },
  {
    "name": "สี่แยกเซ็นทรัลอุดรธานี",
    "detail": "277 ฑีฆะนานนท์ ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.404416935305246, 102.79981900182639",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_38.stream/playlist.m3u8"
  },
  {
    "name": "สี่แยกเทพารักษ์",
    "detail": "สี่แยกเทพารักษ์",
    "provine": "อุดรธานี",
    "gps": "17.42221447607235, 102.77796740971286",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Bosch_IP2.3.stream/playlist.m3u8"
  },
  {
    "name": "สี่แยก VT แหนมเนือง",
    "detail": "สี่แยก VT แหนมเนือง",
    "provine": "อุดรธานี",
    "gps": "17.41349376891392, 102.77721936667521",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Bosch_IP2.9.stream/playlist.m3u8"
  },
  {
    "name": "สี่แยกต้อยลาบเป็ด",
    "detail": "ซอยต้อยลาบเป็ด ถ. มิตรภาพ ตำบลหมากแข้ง อ.เมือง อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.403553304316272, 102.78383931104129",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Bosch_IP2.17.stream/playlist.m3u8"
  },
  {
    "name": "สี่แยกตะวันแดง",
    "detail": "สี่แยกตะวันแดง",
    "provine": "อุดรธานี",
    "gps": "17.408160693135528, 102.8018560516476",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Bosch_IP2.27.stream/playlist.m3u8"
  },
  {
    "name": "จุดสามแยกสี่ศรัทธา",
    "detail": "ถนน สี่ศรัทธา ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.411173477297424, 102.7923801622701",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_IP754.stream/playlist.m3u8"
  },
  {
    "name": "แยกวิทยาลัยอาชีวศึกษาอุดรธานี",
    "detail": "CQ5H+XPQ ตำบล บ้านเลื่อม อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.410112241258744, 102.77752287190468",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_7.21.stream/playlist.m3u8"
  },
  {
    "name": "แยกวิทยาลัยอาชีวศึกษาอุดรธานีถนนเพาะนิยม",
    "detail": "CQ5H+XPQ ตำบล บ้านเลื่อม อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.410112241258744, 102.77752287190468",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_IP724.stream/playlist.m3u8"
  },
  {
    "name": "แยกเรือนจำอุดร",
    "detail": "64 ถนนศรีสุข ซอย ๔ ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.405122465599185, 102.78670558798312",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_IP729.stream/playlist.m3u8"
  },
  {
    "name": "หลังโรงเรียนบ้านหมากแข้ง",
    "detail": "133 ถนน อำเภอ ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.403040254946937, 102.79043869689569",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Bosch_IP2.20.stream/playlist.m3u8"
  },
  {
    "name": "โรงเรียนสตรีอุดร",
    "detail": "โรงเรียนสตรีราชินูทิศ 103 ถ. ศรีสุข ตำบล บ้านเลื่อม อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.40912578337352, 102.77902033319022",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_IP106.stream/playlist.m3u8"
  },
  {
    "name": "ที่กลับรถคตลาดเมืองทองขาออก",
    "detail": "777 7 ถ. นิตโย ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.390889439712545, 102.81852380174921",
    "type": "เทศบาล",
    "url": "http: //61.19.29.251:1935/live/Axis_12_30.stream/playlist.m3u8"
  },
  {
    "name": "แยกตลาดไทยอีสาน",
    "detail": "ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.403181338878877, 102.79702597221569",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_21.stream/playlist.m3u8"
  },
  {
    "name": "ปากซอยประชาสันติ",
    "detail": "ตำบลบ้านจั่น อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.346904117436953, 102.81744976225349",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_27.stream/playlist.m3u8"
  },
  {
    "name": "ปากซอยโรงเรียนอุดรคริสเตียน",
    "detail": "229/1 ถนนอุดรดุษฎี ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.42503511311045, 102.79057922064294",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_53.stream/playlist.m3u8"
  },
  {
    "name": "ปากซอยโรงเรียนอุดรพิทยานุกูล",
    "detail": "CQ4M+G28 ถนนศรีสุข ซอย ๔ ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.40701356177605, 102.78323800477347",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_IP727.stream/playlist.m3u8"
  },
  {
    "name": "ปากซอยโรงเรียนอนุบาลลูกรัก",
    "detail": "CQFG+GHQ ถนนธรรมเจดีย์ (หลังวัดโพธิสมภรณ์) เมืองอุดรธานี อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.424837207090054, 102.77702779101088",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Bosch_IP2.2.stream/playlist.m3u8"
  },
  {
    "name": "แยกกรมชลประทานอุดร",
    "detail": "21 ถนน วัฒนานุวงศ์ ตำบลหมากแข้ง อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.412787575742787, 102.79329480561982",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_45.stream/playlist.m3u8"
  },
  {
    "name": "แยกสนามกีฬาเวสสุวรรณ",
    "detail": "9RW5+8XM เทศบาลตำบลหนองบัว อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.39589115780377, 102.80989697149282",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Bosch_IP2.30.stream/playlist.m3u8"
  },
  {
    "name": "แยกธิเบต",
    "detail": "CQ5X+MX8 ถนน ถ. อดุลยเดช อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.409177451027162, 102.79993299981845",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_12_43.stream/playlist.m3u8"
  },
  {
    "name": "แยกร่วมทวี",
    "detail": "9RPG+RC2 22 เทศบาลตำบลหนองบัว อำเภอเมืองอุดรธานี อุดรธานี 41000",
    "provine": "อุดรธานี",
    "gps": "17.38669082600626, 102.8263624189968",
    "type": "เทศบาล",
    "url": "https://streaming.udoncity.go.th:1935/live/Axis_1_81.stream/playlist.m3u8"
  }
]


export default cctvData;
